export const PATH_ID = 'id';
export const ITEM_ID = 'id';
export const PATH_USER_RIGHTS = 'userRights';
export const ITEM_USER_RIGHTS = 'userRights';
export const PATH_MODIFIED_DATE = 'modifiedDate';
export const ITEM_MODIFIED_DATE = 'modifiedDate';
export const PATH_MUST_RECALCULATE = 'mustRecalculate';
export const ITEM_MUST_RECALCULATE = 'mustRecalculate';
export const PATH_VERTRAGS_AENDERUNG = 'vertragsAenderung';
export const ITEM_VERTRAGS_AENDERUNG = 'vertragsAenderung';
export const PATH_LEISTUNGSFALL = 'leistungsfall';
export const ITEM_LEISTUNGSFALL = 'leistungsfall';
export const PATH_AKTEN_TRENNUNG = 'aktenTrennung';
export const ITEM_AKTEN_TRENNUNG = 'aktenTrennung';
export const PATH_GLOBAL_WARNING = 'globalWarning';
export const ITEM_GLOBAL_WARNING = 'globalWarning';
export const PATH_AKTEN_ZUSAMMENLEGUNG = 'aktenZusammenlegung';
export const ITEM_AKTEN_ZUSAMMENLEGUNG = 'aktenZusammenlegung';
export const PATH_IDD_BERATUNG_DURCHGEFUEHRT = 'iddBeratungDurchgefuehrt';
export const ITEM_IDD_BERATUNG_DURCHGEFUEHRT = 'iddBeratungDurchgefuehrt';
export const PATH_VERTRAGS_AENDERUNG_INITIALISIERT = 'vertragsAenderungInitialisiert';
export const ITEM_VERTRAGS_AENDERUNG_INITIALISIERT = 'vertragsAenderungInitialisiert';
export const PATH_VERTRAGS_AENDERUNGS_DATUM = 'vertragsAenderungsDatum';
export const ITEM_VERTRAGS_AENDERUNGS_DATUM = 'vertragsAenderungsDatum';
export const PATH_VERTRAGSZUSTAND_PER_DATUM = 'vertragszustandPerDatum';
export const ITEM_VERTRAGSZUSTAND_PER_DATUM = 'vertragszustandPerDatum';
export const PATH_TODES_DATUM_ALTER_VN = 'todesDatumAlterVn';
export const ITEM_TODES_DATUM_ALTER_VN = 'todesDatumAlterVn';
export const PATH_TARIF_VERSION_STICHTAG = 'tarifVersionStichtag';
export const ITEM_TARIF_VERSION_STICHTAG = 'tarifVersionStichtag';
export const PATH_VERMITTLER_INFO = 'vermittlerInfo';
export const ITEM_VERMITTLER_INFO = 'vermittlerInfo';
export const PATH_VERMITTLER_INFO_VERMITTLER_NR = 'vermittlerInfo.vermittlerNr';
export const ITEM_VERMITTLER_INFO_VERMITTLER_NR = 'vermittlerNr';
export const PATH_VERMITTLER_INFO_VERMITTLER_NAME = 'vermittlerInfo.vermittlerName';
export const ITEM_VERMITTLER_INFO_VERMITTLER_NAME = 'vermittlerName';
export const PATH_VERMITTLER_INFO_VERMITTLER_NAME_NACHNAME = 'vermittlerInfo.vermittlerName.nachname';
export const ITEM_VERMITTLER_INFO_VERMITTLER_NAME_NACHNAME = 'nachname';
export const PATH_VERMITTLER_INFO_VERMITTLER_NAME_VORNAME = 'vermittlerInfo.vermittlerName.vorname';
export const ITEM_VERMITTLER_INFO_VERMITTLER_NAME_VORNAME = 'vorname';
export const PATH_VERMITTLER_INFO_MAKLER = 'vermittlerInfo.makler';
export const ITEM_VERMITTLER_INFO_MAKLER = 'makler';
export const PATH_VERMITTLER_INFO_COURTAGE = 'vermittlerInfo.courtage';
export const ITEM_VERMITTLER_INFO_COURTAGE = 'courtage';
export const PATH_VERMITTLER_INFO_HAS_GV = 'vermittlerInfo.hasGv';
export const ITEM_VERMITTLER_INFO_HAS_GV = 'hasGv';
export const PATH_VERMITTLER_INFO_HAS_LV = 'vermittlerInfo.hasLv';
export const ITEM_VERMITTLER_INFO_HAS_LV = 'hasLv';
export const PATH_VERMITTLER_INFO_HAS_SV = 'vermittlerInfo.hasSv';
export const ITEM_VERMITTLER_INFO_HAS_SV = 'hasSv';
export const PATH_VERMITTLER_INFO_HAS_UV = 'vermittlerInfo.hasUv';
export const ITEM_VERMITTLER_INFO_HAS_UV = 'hasUv';
export const PATH_VERMITTLER_INFO_VSE_REQUIRED = 'vermittlerInfo.vseRequired';
export const ITEM_VERMITTLER_INFO_VSE_REQUIRED = 'vseRequired';
export const PATH_VERMITTLER_INFO_KOOPERATIONSPARTNER = 'vermittlerInfo.kooperationspartner';
export const ITEM_VERMITTLER_INFO_KOOPERATIONSPARTNER = 'kooperationspartner';
export const PATH_VERMITTLER_INFO_ABKOMMEN = 'vermittlerInfo.abkommen';
export const ITEM_VERMITTLER_INFO_ABKOMMEN = 'abkommen';
export const PATH_VERMITTLER_INFO_ABBER_TYPE = 'vermittlerInfo.abberType';
export const ITEM_VERMITTLER_INFO_ABBER_TYPE = 'abberType';
export const PATH_VERMITTLER_INFO_IS_MAKLERSPITZE = 'vermittlerInfo.isMaklerspitze';
export const ITEM_VERMITTLER_INFO_IS_MAKLERSPITZE = 'isMaklerspitze';
export const PATH_VERMITTLER_INFO_IS_TEAM_PARTNER_SPITZE = 'vermittlerInfo.isTeamPartnerSpitze';
export const ITEM_VERMITTLER_INFO_IS_TEAM_PARTNER_SPITZE = 'isTeamPartnerSpitze';
export const PATH_VERMITTLER_INFO_HAS_DISPLAYABLE_SUBORDINATES = 'vermittlerInfo.hasDisplayableSubordinates';
export const ITEM_VERMITTLER_INFO_HAS_DISPLAYABLE_SUBORDINATES = 'hasDisplayableSubordinates';
export const PATH_VERMITTLER_INFO_BLATT_ABBER = 'vermittlerInfoBlattAbber';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER = 'vermittlerInfoBlattAbber';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NR = 'vermittlerInfoBlattAbber.vermittlerNr';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NR = 'vermittlerNr';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME = 'vermittlerInfoBlattAbber.vermittlerName';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME = 'vermittlerName';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_NACHNAME =
  'vermittlerInfoBlattAbber.vermittlerName.nachname';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_NACHNAME = 'nachname';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_VORNAME =
  'vermittlerInfoBlattAbber.vermittlerName.vorname';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_VORNAME = 'vorname';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_MAKLER = 'vermittlerInfoBlattAbber.makler';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_MAKLER = 'makler';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_COURTAGE = 'vermittlerInfoBlattAbber.courtage';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_COURTAGE = 'courtage';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_HAS_GV = 'vermittlerInfoBlattAbber.hasGv';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_HAS_GV = 'hasGv';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_HAS_LV = 'vermittlerInfoBlattAbber.hasLv';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_HAS_LV = 'hasLv';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_HAS_SV = 'vermittlerInfoBlattAbber.hasSv';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_HAS_SV = 'hasSv';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_HAS_UV = 'vermittlerInfoBlattAbber.hasUv';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_HAS_UV = 'hasUv';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_VSE_REQUIRED = 'vermittlerInfoBlattAbber.vseRequired';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_VSE_REQUIRED = 'vseRequired';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_KOOPERATIONSPARTNER = 'vermittlerInfoBlattAbber.kooperationspartner';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_KOOPERATIONSPARTNER = 'kooperationspartner';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_ABKOMMEN = 'vermittlerInfoBlattAbber.abkommen';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_ABKOMMEN = 'abkommen';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_ABBER_TYPE = 'vermittlerInfoBlattAbber.abberType';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_ABBER_TYPE = 'abberType';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_IS_MAKLERSPITZE = 'vermittlerInfoBlattAbber.isMaklerspitze';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_IS_MAKLERSPITZE = 'isMaklerspitze';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_IS_TEAM_PARTNER_SPITZE = 'vermittlerInfoBlattAbber.isTeamPartnerSpitze';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_IS_TEAM_PARTNER_SPITZE = 'isTeamPartnerSpitze';
export const PATH_VERMITTLER_INFO_BLATT_ABBER_HAS_DISPLAYABLE_SUBORDINATES =
  'vermittlerInfoBlattAbber.hasDisplayableSubordinates';
export const ITEM_VERMITTLER_INFO_BLATT_ABBER_HAS_DISPLAYABLE_SUBORDINATES = 'hasDisplayableSubordinates';
export const PATH_FZ_KONTO = 'fzKonto';
export const ITEM_FZ_KONTO = 'fzKonto';
export const PATH_FZ_KONTO_KONTO = 'fzKonto.konto';
export const ITEM_FZ_KONTO_KONTO = 'konto';
export const PATH_FZ_KONTO_KONTO_NAME = 'fzKonto.kontoName';
export const ITEM_FZ_KONTO_KONTO_NAME = 'kontoName';
export const PATH_FZ_KONTO_EXKLUSIV_ABBER_NR = 'fzKonto.exklusivAbberNr';
export const ITEM_FZ_KONTO_EXKLUSIV_ABBER_NR = 'exklusivAbberNr';
export const PATH_FZ_KONTO_VERRECHNUNGSART = 'fzKonto.verrechnungsart';
export const ITEM_FZ_KONTO_VERRECHNUNGSART = 'verrechnungsart';
export const PATH_FZ_KONTO_BEZEICHNUNG = 'fzKonto.bezeichnung';
export const ITEM_FZ_KONTO_BEZEICHNUNG = 'bezeichnung';
export const PATH_FZ_KONTO_HINWEIS = 'fzKonto.hinweis';
export const ITEM_FZ_KONTO_HINWEIS = 'hinweis';
export const PATH_FZ_KONTO_GILT_VON = 'fzKonto.giltVon';
export const ITEM_FZ_KONTO_GILT_VON = 'giltVon';
export const PATH_FZ_KONTO_GILT_BIS = 'fzKonto.giltBis';
export const ITEM_FZ_KONTO_GILT_BIS = 'giltBis';
export const PATH_FZ_KONTO_PERSONAL_NUMMER = 'fzKonto.personalNummer';
export const ITEM_FZ_KONTO_PERSONAL_NUMMER = 'personalNummer';
export const PATH_FZ_KONTO_PERSONAL_NUMMER_REGEX = 'fzKonto.personalNummerRegex';
export const ITEM_FZ_KONTO_PERSONAL_NUMMER_REGEX = 'personalNummerRegex';
export const PATH_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION = 'fzKonto.personalNummerExplanation';
export const ITEM_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION = 'personalNummerExplanation';
export const PATH_FZ_KONTO_DIENSTSTELLE_REQUIRED = 'fzKonto.dienststelleRequired';
export const ITEM_FZ_KONTO_DIENSTSTELLE_REQUIRED = 'dienststelleRequired';
export const PATH_FZ_KONTO_PERS_NR_ERFORDERLICH = 'fzKonto.persNrErforderlich';
export const ITEM_FZ_KONTO_PERS_NR_ERFORDERLICH = 'persNrErforderlich';
export const PATH_BESTAND_FZ_KONTO = 'bestandFzKonto';
export const ITEM_BESTAND_FZ_KONTO = 'bestandFzKonto';
export const PATH_BESTAND_FZ_KONTO_KONTO = 'bestandFzKonto.konto';
export const ITEM_BESTAND_FZ_KONTO_KONTO = 'konto';
export const PATH_BESTAND_FZ_KONTO_KONTO_NAME = 'bestandFzKonto.kontoName';
export const ITEM_BESTAND_FZ_KONTO_KONTO_NAME = 'kontoName';
export const PATH_BESTAND_FZ_KONTO_EXKLUSIV_ABBER_NR = 'bestandFzKonto.exklusivAbberNr';
export const ITEM_BESTAND_FZ_KONTO_EXKLUSIV_ABBER_NR = 'exklusivAbberNr';
export const PATH_BESTAND_FZ_KONTO_VERRECHNUNGSART = 'bestandFzKonto.verrechnungsart';
export const ITEM_BESTAND_FZ_KONTO_VERRECHNUNGSART = 'verrechnungsart';
export const PATH_BESTAND_FZ_KONTO_BEZEICHNUNG = 'bestandFzKonto.bezeichnung';
export const ITEM_BESTAND_FZ_KONTO_BEZEICHNUNG = 'bezeichnung';
export const PATH_BESTAND_FZ_KONTO_HINWEIS = 'bestandFzKonto.hinweis';
export const ITEM_BESTAND_FZ_KONTO_HINWEIS = 'hinweis';
export const PATH_BESTAND_FZ_KONTO_GILT_VON = 'bestandFzKonto.giltVon';
export const ITEM_BESTAND_FZ_KONTO_GILT_VON = 'giltVon';
export const PATH_BESTAND_FZ_KONTO_GILT_BIS = 'bestandFzKonto.giltBis';
export const ITEM_BESTAND_FZ_KONTO_GILT_BIS = 'giltBis';
export const PATH_BESTAND_FZ_KONTO_PERSONAL_NUMMER = 'bestandFzKonto.personalNummer';
export const ITEM_BESTAND_FZ_KONTO_PERSONAL_NUMMER = 'personalNummer';
export const PATH_BESTAND_FZ_KONTO_PERSONAL_NUMMER_REGEX = 'bestandFzKonto.personalNummerRegex';
export const ITEM_BESTAND_FZ_KONTO_PERSONAL_NUMMER_REGEX = 'personalNummerRegex';
export const PATH_BESTAND_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION = 'bestandFzKonto.personalNummerExplanation';
export const ITEM_BESTAND_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION = 'personalNummerExplanation';
export const PATH_BESTAND_FZ_KONTO_DIENSTSTELLE_REQUIRED = 'bestandFzKonto.dienststelleRequired';
export const ITEM_BESTAND_FZ_KONTO_DIENSTSTELLE_REQUIRED = 'dienststelleRequired';
export const PATH_BESTAND_FZ_KONTO_PERS_NR_ERFORDERLICH = 'bestandFzKonto.persNrErforderlich';
export const ITEM_BESTAND_FZ_KONTO_PERS_NR_ERFORDERLICH = 'persNrErforderlich';
export const PATH_CONFIG = 'config';
export const ITEM_CONFIG = 'config';
export const PATH_CONFIG_STICHTAG_VERS_BEGINN = 'config.stichtagVersBeginn';
export const ITEM_CONFIG_STICHTAG_VERS_BEGINN = 'stichtagVersBeginn';
export const PATH_CONFIG_STICHDATUM_MAX_OFFSET = 'config.stichdatumMaxOffset';
export const ITEM_CONFIG_STICHDATUM_MAX_OFFSET = 'stichdatumMaxOffset';
export const PATH_CONFIG_GV_EXTRA_WEEKS_FORMALE_AENDERUNG_IM_LEISTUNGSFALL =
  'config.gvExtraWeeksFormaleAenderungImLeistungsfall';
export const ITEM_CONFIG_GV_EXTRA_WEEKS_FORMALE_AENDERUNG_IM_LEISTUNGSFALL =
  'gvExtraWeeksFormaleAenderungImLeistungsfall';
export const PATH_CONFIG_GV_VALIDITY_EXCEPTION_DATES = 'config.gvValidityExceptionDates';
export const ITEM_CONFIG_GV_VALIDITY_EXCEPTION_DATES = 'gvValidityExceptionDates';
export const PATH_CONFIG_GV_VALIDITY_EXCEPTION_DATES_FROM = 'config.gvValidityExceptionDates.from';
export const ITEM_CONFIG_GV_VALIDITY_EXCEPTION_DATES_FROM = 'from';
export const PATH_CONFIG_GV_VALIDITY_EXCEPTION_DATES_TO = 'config.gvValidityExceptionDates.to';
export const ITEM_CONFIG_GV_VALIDITY_EXCEPTION_DATES_TO = 'to';
export const PATH_CONFIG_GV_VALIDITY_EXCEPTION_DATES_FIXED = 'config.gvValidityExceptionDates.fixed';
export const ITEM_CONFIG_GV_VALIDITY_EXCEPTION_DATES_FIXED = 'fixed';
export const PATH_GV_PERSONEN_DATA = 'gvPersonenData';
export const ITEM_GV_PERSONEN_DATA = 'gvPersonenData';
export const PATH_GV_PERSONEN_DATA_GESAMT_PRAEMIE = 'gvPersonenData.gesamtPraemie';
export const ITEM_GV_PERSONEN_DATA_GESAMT_PRAEMIE = 'gesamtPraemie';
export const PATH_GV_PERSONEN_DATA_PERSONEN = 'gvPersonenData.personen';
export const ITEM_GV_PERSONEN_DATA_PERSONEN = 'personen';
export const PATH_GV_PERSONEN_DATA_PERSONEN_ID = 'gvPersonenData.personen.id';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_ID = 'id';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PRAEMIE_PERSON = 'gvPersonenData.personen.praemiePerson';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PRAEMIE_PERSON = 'praemiePerson';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN = 'gvPersonenData.personen.stammdaten';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN = 'stammdaten';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR = 'gvPersonenData.personen.stammdaten.partnerNr';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR = 'partnerNr';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT = 'gvPersonenData.personen.stammdaten.geschlecht';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT = 'geschlecht';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME = 'gvPersonenData.personen.stammdaten.vorname';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME = 'vorname';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL = 'gvPersonenData.personen.stammdaten.titel';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL = 'titel';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT =
  'gvPersonenData.personen.stammdaten.titelNachgestellt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT = 'titelNachgestellt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL = 'gvPersonenData.personen.stammdaten.berufstitel';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL = 'berufstitel';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP = 'gvPersonenData.personen.stammdaten.timeStamp';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP = 'timeStamp';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME = 'gvPersonenData.personen.stammdaten.name';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME = 'name';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM = 'gvPersonenData.personen.stammdaten.gebdatum';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM = 'gebdatum';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND =
  'gvPersonenData.personen.stammdaten.familienstand';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND = 'familienstand';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG =
  'gvPersonenData.personen.stammdaten.berufsbezeichnung';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG = 'berufsbezeichnung';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART =
  'gvPersonenData.personen.stammdaten.beschaeftigungsart';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART = 'beschaeftigungsart';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI =
  'gvPersonenData.personen.stammdaten.beschaeftigtBei';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI = 'beschaeftigtBei';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND = 'gvPersonenData.personen.stammdaten.geburtsland';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND = 'geburtsland';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET =
  'gvPersonenData.personen.stammdaten.nationalitaet';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET = 'nationalitaet';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON =
  'gvPersonenData.personen.stammdaten.juristischePerson';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON = 'juristischePerson';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT =
  'gvPersonenData.personen.stammdaten.sozversanstalt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT = 'sozversanstalt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE =
  'gvPersonenData.personen.stammdaten.merkurEmployee';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE = 'merkurEmployee';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER =
  'gvPersonenData.personen.stammdaten.versicherungsnummer';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER = 'versicherungsnummer';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE = 'gvPersonenData.personen.stammdaten.adresse';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE = 'adresse';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE =
  'gvPersonenData.personen.stammdaten.adresse.strasse';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE = 'strasse';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR =
  'gvPersonenData.personen.stammdaten.adresse.hausnr';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR = 'hausnr';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ = 'gvPersonenData.personen.stammdaten.adresse.ikz';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ = 'ikz';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT = 'gvPersonenData.personen.stammdaten.adresse.ort';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT = 'ort';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ = 'gvPersonenData.personen.stammdaten.adresse.plz';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ = 'plz';
export const PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME =
  'gvPersonenData.personen.stammdaten.sozversanstaltName';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME = 'sozversanstaltName';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN = 'gvPersonenData.personen.personRollen';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN = 'personRollen';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN = 'gvPersonenData.personen.personRollen.vn';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN = 'vn';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP = 'gvPersonenData.personen.personRollen.vp';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP = 'vp';
export const PATH_GV_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH =
  'gvPersonenData.personen.hauptwohnsitzOesterreich';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH = 'hauptwohnsitzOesterreich';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN = 'gvPersonenData.personen.personBeziehungen';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN = 'personBeziehungen';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG =
  'gvPersonenData.personen.personBeziehungen.vnBeziehung';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG = 'vnBeziehung';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID =
  'gvPersonenData.personen.personBeziehungen.elternteilPersonId';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID = 'elternteilPersonId';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID_2 =
  'gvPersonenData.personen.personBeziehungen.elternteilPersonId2';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID_2 = 'elternteilPersonId2';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_IN_AUSBILDUNG =
  'gvPersonenData.personen.personBeziehungen.inAusbildung';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_IN_AUSBILDUNG = 'inAusbildung';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO =
  'gvPersonenData.personen.personBeziehungen.schwangerschaftsInfo';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO = 'schwangerschaftsInfo';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_SCHWANGER =
  'gvPersonenData.personen.personBeziehungen.schwangerschaftsInfo.schwanger';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_SCHWANGER = 'schwanger';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_DECKUNG =
  'gvPersonenData.personen.personBeziehungen.schwangerschaftsInfo.deckung';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_DECKUNG = 'deckung';
export const PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_KINDS_VATER_PERSON_ID =
  'gvPersonenData.personen.personBeziehungen.schwangerschaftsInfo.kindsVaterPersonId';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_KINDS_VATER_PERSON_ID =
  'kindsVaterPersonId';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA = 'gvPersonenData.personen.gvTarifData';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA = 'gvTarifData';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE = 'gvPersonenData.personen.gvTarifData.tarife';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE = 'tarife';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_NR =
  'gvPersonenData.personen.gvTarifData.tarife.risikoNr';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_NR = 'risikoNr';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_PRAEM_ART =
  'gvPersonenData.personen.gvTarifData.tarife.versPraemArt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_PRAEM_ART = 'versPraemArt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZAHLWEISE =
  'gvPersonenData.personen.gvTarifData.tarife.zahlweise';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZAHLWEISE = 'zahlweise';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_HAUPTGRUPPEN =
  'gvPersonenData.personen.gvTarifData.tarife.hauptgruppen';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_HAUPTGRUPPEN = 'hauptgruppen';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEWAEHLT =
  'gvPersonenData.personen.gvTarifData.tarife.ausgewaehlt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEWAEHLT = 'ausgewaehlt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_EHEPAAR_RABATT =
  'gvPersonenData.personen.gvTarifData.tarife.ehepaarRabatt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_EHEPAAR_RABATT = 'ehepaarRabatt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GK_KONTO_GVAU =
  'gvPersonenData.personen.gvTarifData.tarife.gkKontoGvau';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GK_KONTO_GVAU = 'gkKontoGvau';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUKUENFTIGES_RISIKO =
  'gvPersonenData.personen.gvTarifData.tarife.zukuenftigesRisiko';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUKUENFTIGES_RISIKO = 'zukuenftigesRisiko';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERBLEIB_IN_ALTER_TARIFSERIE =
  'gvPersonenData.personen.gvTarifData.tarife.verbleibInAlterTarifserie';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERBLEIB_IN_ALTER_TARIFSERIE =
  'verbleibInAlterTarifserie';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE =
  'gvPersonenData.personen.gvTarifData.tarife.praemie';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE = 'praemie';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FAKTOR =
  'gvPersonenData.personen.gvTarifData.tarife.faktor';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FAKTOR = 'faktor';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_PROZENT =
  'gvPersonenData.personen.gvTarifData.tarife.risikoProzent';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_PROZENT = 'risikoProzent';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERSICHERUNGS_BEGINN =
  'gvPersonenData.personen.gvTarifData.tarife.versicherungsBeginn';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERSICHERUNGS_BEGINN = 'versicherungsBeginn';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ECHT_BEGINN =
  'gvPersonenData.personen.gvTarifData.tarife.echtBeginn';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ECHT_BEGINN = 'echtBeginn';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TECH_BEGINN =
  'gvPersonenData.personen.gvTarifData.tarife.techBeginn';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TECH_BEGINN = 'techBeginn';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONVERTIERUNGS_BASIS_RISIKO_NR =
  'gvPersonenData.personen.gvTarifData.tarife.konvertierungsBasisRisikoNr';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONVERTIERUNGS_BASIS_RISIKO_NR =
  'konvertierungsBasisRisikoNr';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VB_TEXT =
  'gvPersonenData.personen.gvTarifData.tarife.vbText';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VB_TEXT = 'vbText';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_TYP =
  'gvPersonenData.personen.gvTarifData.tarife.risikoTyp';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_TYP = 'risikoTyp';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GESCHAEFTSFALL =
  'gvPersonenData.personen.gvTarifData.tarife.geschaeftsfall';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GESCHAEFTSFALL = 'geschaeftsfall';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIENBEFREIUNG =
  'gvPersonenData.personen.gvTarifData.tarife.praemienbefreiung';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIENBEFREIUNG = 'praemienbefreiung';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONV_BASIS_TARIF_SCHL =
  'gvPersonenData.personen.gvTarifData.tarife.konvBasisTarifSchl';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONV_BASIS_TARIF_SCHL = 'konvBasisTarifSchl';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FROM_IDD_BEDARF =
  'gvPersonenData.personen.gvTarifData.tarife.fromIddBedarf';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FROM_IDD_BEDARF = 'fromIddBedarf';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AVB_CODE =
  'gvPersonenData.personen.gvTarifData.tarife.avbCode';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AVB_CODE = 'avbCode';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE_ERWACHSEN =
  'gvPersonenData.personen.gvTarifData.tarife.praemieErwachsen';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE_ERWACHSEN = 'praemieErwachsen';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ALTER_ERWACHSEN =
  'gvPersonenData.personen.gvTarifData.tarife.alterErwachsen';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ALTER_ERWACHSEN = 'alterErwachsen';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GV_ALTER =
  'gvPersonenData.personen.gvTarifData.tarife.gvAlter';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GV_ALTER = 'gvAlter';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_LEISTUNGSAUSSCHLUSS =
  'gvPersonenData.personen.gvTarifData.tarife.leistungsausschluss';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_LEISTUNGSAUSSCHLUSS = 'leistungsausschluss';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO = 'tarifInfo';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KBEZ =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifKbez';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KBEZ = 'tarifKbez';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SCHL =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifSchl';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SCHL = 'tarifSchl';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BEZ =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifBez';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BEZ = 'tarifBez';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_TEXT =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifText';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_TEXT = 'tarifText';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_HIERARCHIE =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.hierarchie';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_HIERARCHIE = 'hierarchie';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_FIRMEN_TARIF =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.firmenTarif';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_FIRMEN_TARIF = 'firmenTarif';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_GESPERRT_AB =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.gesperrtAb';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_GESPERRT_AB = 'gesperrtAb';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KRANKEN_ANSTALTEN =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.krankenAnstalten';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KRANKEN_ANSTALTEN = 'krankenAnstalten';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_BIS =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.kostenDeckungBis';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_BIS = 'kostenDeckungBis';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_VON =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.kostenDeckungVon';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_VON = 'kostenDeckungVon';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_GRUPPE =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.konvGruppe';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_GRUPPE = 'konvGruppe';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BAUSTEIN_GRUPPE =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifBausteinGruppe';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BAUSTEIN_GRUPPE =
  'tarifBausteinGruppe';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifBundeslandNichtDeckungsBundesland';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'tarifBundeslandNichtDeckungsBundesland';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_VK_GESPERRT =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.vkGesperrt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_VK_GESPERRT = 'vkGesperrt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_OE_TARIF =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.oeTarif';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_OE_TARIF = 'oeTarif';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_IN_GKKTARI =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.inGkktari';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_IN_GKKTARI = 'inGkktari';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_NUR_IN_GD =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.konvNurInGD';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_NUR_IN_GD = 'konvNurInGD';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_PK =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.pk';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_PK = 'pk';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_GRUPPE =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifGruppe';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_GRUPPE = 'tarifGruppe';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_BUNDESLAND =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.bundesland';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_BUNDESLAND = 'bundesland';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZWEIG =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifZweig';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZWEIG = 'tarifZweig';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_ANSTALTEN =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.sozVersAnstalten';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_ANSTALTEN = 'sozVersAnstalten';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_TARIF_GRP =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.sozVersTarifGrp';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_TARIF_GRP = 'sozVersTarifGrp';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SELEKTIONS_GRUPPE_1 =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifSelektionsGruppe1';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SELEKTIONS_GRUPPE_1 =
  'tarifSelektionsGruppe1';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_HAUPT_GRUPPEN =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifHauptGruppen';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_HAUPT_GRUPPEN = 'tarifHauptGruppen';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KLASSE_RIKO_PR =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifKlasseRikoPr';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KLASSE_RIKO_PR = 'tarifKlasseRikoPr';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZUSATZ_GRUPPEN =
  'gvPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifZusatzGruppen';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZUSATZ_GRUPPEN = 'tarifZusatzGruppen';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE =
  'gvPersonenData.personen.gvTarifData.tarife.zusaetze';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE = 'zusaetze';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_SCHL =
  'gvPersonenData.personen.gvTarifData.tarife.zusaetze.tarifSchl';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_SCHL = 'tarifSchl';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_KURZ_BEZEICHNUNG =
  'gvPersonenData.personen.gvTarifData.tarife.zusaetze.kurzBezeichnung';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_KURZ_BEZEICHNUNG = 'kurzBezeichnung';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_LANG_BEZEICHNUNG =
  'gvPersonenData.personen.gvTarifData.tarife.zusaetze.langBezeichnung';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_LANG_BEZEICHNUNG = 'langBezeichnung';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_ZUSATZ_PRAEMIE =
  'gvPersonenData.personen.gvTarifData.tarife.zusaetze.tarifZusatzPraemie';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_ZUSATZ_PRAEMIE = 'tarifZusatzPraemie';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE =
  'gvPersonenData.personen.gvTarifData.tarife.sonderRabatte';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE = 'sonderRabatte';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_ZUSCHLAG_ART =
  'gvPersonenData.personen.gvTarifData.tarife.sonderRabatte.zuschlagArt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_ZUSCHLAG_ART = 'zuschlagArt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_PROZENT =
  'gvPersonenData.personen.gvTarifData.tarife.sonderRabatte.prozent';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_PROZENT = 'prozent';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE =
  'gvPersonenData.personen.gvTarifData.tarife.rabatte';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE = 'rabatte';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_ZUSCHLAG_ART =
  'gvPersonenData.personen.gvTarifData.tarife.rabatte.zuschlagArt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_ZUSCHLAG_ART = 'zuschlagArt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_PROZENT =
  'gvPersonenData.personen.gvTarifData.tarife.rabatte.prozent';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_PROZENT = 'prozent';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_RABATT_ART =
  'gvPersonenData.personen.gvTarifData.tarife.rabatte.rabattArt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_RABATT_ART = 'rabattArt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_VERRECHNUNGSKONTO =
  'gvPersonenData.personen.gvTarifData.tarife.rabatte.verrechnungskonto';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_VERRECHNUNGSKONTO = 'verrechnungskonto';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_CODE =
  'gvPersonenData.personen.gvTarifData.tarife.rabatte.code';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_CODE = 'code';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS =
  'gvPersonenData.personen.gvTarifData.tarife.klauselDetails';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS = 'klauselDetails';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_NUMMER =
  'gvPersonenData.personen.gvTarifData.tarife.klauselDetails.klauselNummer';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_NUMMER = 'klauselNummer';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_BIS =
  'gvPersonenData.personen.gvTarifData.tarife.klauselDetails.klauselBis';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_BIS = 'klauselBis';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_BED =
  'gvPersonenData.personen.gvTarifData.tarife.versBed';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_BED = 'versBed';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO = 'fzKonto';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.konto';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO = 'konto';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO_NAME =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.kontoName';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO_NAME = 'kontoName';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_EXKLUSIV_ABBER_NR =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.exklusivAbberNr';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_EXKLUSIV_ABBER_NR = 'exklusivAbberNr';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_VERRECHNUNGSART =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.verrechnungsart';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_VERRECHNUNGSART = 'verrechnungsart';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_BEZEICHNUNG =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.bezeichnung';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_BEZEICHNUNG = 'bezeichnung';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_HINWEIS =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.hinweis';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_HINWEIS = 'hinweis';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_VON =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.giltVon';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_VON = 'giltVon';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_BIS =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.giltBis';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_BIS = 'giltBis';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.personalNummer';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER = 'personalNummer';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_REGEX =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.personalNummerRegex';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_REGEX = 'personalNummerRegex';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.personalNummerExplanation';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION =
  'personalNummerExplanation';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_DIENSTSTELLE_REQUIRED =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.dienststelleRequired';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_DIENSTSTELLE_REQUIRED =
  'dienststelleRequired';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERS_NR_ERFORDERLICH =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.persNrErforderlich';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERS_NR_ERFORDERLICH = 'persNrErforderlich';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_RABATT =
  'gvPersonenData.personen.gvTarifData.tarife.fzKonto.rabatt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_RABATT = 'rabatt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES = 'berechnungMessages';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE =
  'berechnungMessage';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_TXT =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.txt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_TXT = 'txt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.status';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS =
  'status';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS_DESCRIPTION =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.statusDescription';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS_DESCRIPTION =
  'statusDescription';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.field';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD = 'field';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD_DESCRIPTION =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.fieldDescription';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD_DESCRIPTION =
  'fieldDescription';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_CODE =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.code';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_CODE = 'code';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FROM_AKTUAR_MED =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.fromAktuarMed';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FROM_AKTUAR_MED =
  'fromAktuarMed';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT =
  'tarifNichtkombinierbarMit';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KBEZ =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifKbez';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KBEZ =
  'tarifKbez';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SCHL =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifSchl';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SCHL =
  'tarifSchl';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BEZ =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifBez';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BEZ =
  'tarifBez';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_TEXT =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifText';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_TEXT =
  'tarifText';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_HIERARCHIE =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.hierarchie';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_HIERARCHIE =
  'hierarchie';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_FIRMEN_TARIF =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.firmenTarif';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_FIRMEN_TARIF =
  'firmenTarif';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_GESPERRT_AB =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.gesperrtAb';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_GESPERRT_AB =
  'gesperrtAb';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KRANKEN_ANSTALTEN =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.krankenAnstalten';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KRANKEN_ANSTALTEN =
  'krankenAnstalten';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_BIS =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.kostenDeckungBis';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_BIS =
  'kostenDeckungBis';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_VON =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.kostenDeckungVon';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_VON =
  'kostenDeckungVon';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_GRUPPE =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.konvGruppe';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_GRUPPE =
  'konvGruppe';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BAUSTEIN_GRUPPE =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifBausteinGruppe';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BAUSTEIN_GRUPPE =
  'tarifBausteinGruppe';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifBundeslandNichtDeckungsBundesland';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'tarifBundeslandNichtDeckungsBundesland';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_VK_GESPERRT =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.vkGesperrt';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_VK_GESPERRT =
  'vkGesperrt';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_OE_TARIF =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.oeTarif';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_OE_TARIF =
  'oeTarif';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_IN_GKKTARI =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.inGkktari';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_IN_GKKTARI =
  'inGkktari';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_NUR_IN_GD =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.konvNurInGD';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_NUR_IN_GD =
  'konvNurInGD';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_PK =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.pk';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_PK =
  'pk';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_GRUPPE =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifGruppe';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_GRUPPE =
  'tarifGruppe';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_BUNDESLAND =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.bundesland';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_BUNDESLAND =
  'bundesland';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZWEIG =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifZweig';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZWEIG =
  'tarifZweig';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_ANSTALTEN =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.sozVersAnstalten';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_ANSTALTEN =
  'sozVersAnstalten';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_TARIF_GRP =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.sozVersTarifGrp';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_TARIF_GRP =
  'sozVersTarifGrp';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SELEKTIONS_GRUPPE_1 =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifSelektionsGruppe1';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SELEKTIONS_GRUPPE_1 =
  'tarifSelektionsGruppe1';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_HAUPT_GRUPPEN =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifHauptGruppen';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_HAUPT_GRUPPEN =
  'tarifHauptGruppen';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KLASSE_RIKO_PR =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifKlasseRikoPr';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KLASSE_RIKO_PR =
  'tarifKlasseRikoPr';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZUSATZ_GRUPPEN =
  'gvPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifZusatzGruppen';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZUSATZ_GRUPPEN =
  'tarifZusatzGruppen';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE =
  'gvPersonenData.personen.gvTarifData.tarife.bausteine';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE = 'bausteine';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_KBEZ =
  'gvPersonenData.personen.gvTarifData.tarife.bausteine.kbez';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_KBEZ = 'kbez';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_DRUCK =
  'gvPersonenData.personen.gvTarifData.tarife.bausteine.druck';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_DRUCK = 'druck';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_PRAEMIE =
  'gvPersonenData.personen.gvTarifData.tarife.bausteine.praemie';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_PRAEMIE = 'praemie';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ABLAUF =
  'gvPersonenData.personen.gvTarifData.tarife.ablauf';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ABLAUF = 'ablauf';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_KLASSE =
  'gvPersonenData.personen.gvTarifData.tarife.tarifKlasse';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_KLASSE = 'tarifKlasse';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE =
  'gvPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE = 'erlaubteGeschaeftsfaelle';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_ID =
  'gvPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle.id';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_NAME =
  'gvPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle.name';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_EBENE =
  'gvPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle.ebene';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_EBENE = 'ebene';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'gvPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'ausgefuehrteGeschaeftsfaelle';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID =
  'gvPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle.id';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME =
  'gvPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle.name';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE =
  'gvPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle.ebene';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE = 'ebene';
export const PATH_GV_PERSONEN_DATA_PERSONEN_SOZIAL_VERSICHERUNG = 'gvPersonenData.personen.sozialVersicherung';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_SOZIAL_VERSICHERUNG = 'sozialVersicherung';
export const PATH_GV_PERSONEN_DATA_PERSONEN_NACHVERSICHERUNG_KURZPFLEGE_HAUPTFAELLIGKEIT =
  'gvPersonenData.personen.nachversicherungKurzpflegeHauptfaelligkeit';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_NACHVERSICHERUNG_KURZPFLEGE_HAUPTFAELLIGKEIT =
  'nachversicherungKurzpflegeHauptfaelligkeit';
export const PATH_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE =
  'gvPersonenData.personen.erlaubteGeschaeftsfaelle';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE = 'erlaubteGeschaeftsfaelle';
export const PATH_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_ID =
  'gvPersonenData.personen.erlaubteGeschaeftsfaelle.id';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_NAME =
  'gvPersonenData.personen.erlaubteGeschaeftsfaelle.name';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_EBENE =
  'gvPersonenData.personen.erlaubteGeschaeftsfaelle.ebene';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_EBENE = 'ebene';
export const PATH_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'gvPersonenData.personen.ausgefuehrteGeschaeftsfaelle';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE = 'ausgefuehrteGeschaeftsfaelle';
export const PATH_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID =
  'gvPersonenData.personen.ausgefuehrteGeschaeftsfaelle.id';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME =
  'gvPersonenData.personen.ausgefuehrteGeschaeftsfaelle.name';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE =
  'gvPersonenData.personen.ausgefuehrteGeschaeftsfaelle.ebene';
export const ITEM_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE = 'ebene';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA = 'gvVertragBestandPersonenData';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA = 'gvVertragBestandPersonenData';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_GESAMT_PRAEMIE = 'gvVertragBestandPersonenData.gesamtPraemie';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_GESAMT_PRAEMIE = 'gesamtPraemie';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN = 'gvVertragBestandPersonenData.personen';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN = 'personen';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ID = 'gvVertragBestandPersonenData.personen.id';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ID = 'id';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PRAEMIE_PERSON =
  'gvVertragBestandPersonenData.personen.praemiePerson';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PRAEMIE_PERSON = 'praemiePerson';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN =
  'gvVertragBestandPersonenData.personen.stammdaten';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN = 'stammdaten';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR =
  'gvVertragBestandPersonenData.personen.stammdaten.partnerNr';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR = 'partnerNr';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT =
  'gvVertragBestandPersonenData.personen.stammdaten.geschlecht';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT = 'geschlecht';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME =
  'gvVertragBestandPersonenData.personen.stammdaten.vorname';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME = 'vorname';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL =
  'gvVertragBestandPersonenData.personen.stammdaten.titel';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL = 'titel';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT =
  'gvVertragBestandPersonenData.personen.stammdaten.titelNachgestellt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT = 'titelNachgestellt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL =
  'gvVertragBestandPersonenData.personen.stammdaten.berufstitel';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL = 'berufstitel';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP =
  'gvVertragBestandPersonenData.personen.stammdaten.timeStamp';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP = 'timeStamp';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME =
  'gvVertragBestandPersonenData.personen.stammdaten.name';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME = 'name';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM =
  'gvVertragBestandPersonenData.personen.stammdaten.gebdatum';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM = 'gebdatum';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND =
  'gvVertragBestandPersonenData.personen.stammdaten.familienstand';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND = 'familienstand';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG =
  'gvVertragBestandPersonenData.personen.stammdaten.berufsbezeichnung';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG = 'berufsbezeichnung';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART =
  'gvVertragBestandPersonenData.personen.stammdaten.beschaeftigungsart';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART = 'beschaeftigungsart';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI =
  'gvVertragBestandPersonenData.personen.stammdaten.beschaeftigtBei';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI = 'beschaeftigtBei';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND =
  'gvVertragBestandPersonenData.personen.stammdaten.geburtsland';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND = 'geburtsland';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET =
  'gvVertragBestandPersonenData.personen.stammdaten.nationalitaet';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET = 'nationalitaet';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON =
  'gvVertragBestandPersonenData.personen.stammdaten.juristischePerson';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON = 'juristischePerson';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT =
  'gvVertragBestandPersonenData.personen.stammdaten.sozversanstalt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT = 'sozversanstalt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE =
  'gvVertragBestandPersonenData.personen.stammdaten.merkurEmployee';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE = 'merkurEmployee';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER =
  'gvVertragBestandPersonenData.personen.stammdaten.versicherungsnummer';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER = 'versicherungsnummer';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE =
  'gvVertragBestandPersonenData.personen.stammdaten.adresse';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE = 'adresse';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE =
  'gvVertragBestandPersonenData.personen.stammdaten.adresse.strasse';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE = 'strasse';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR =
  'gvVertragBestandPersonenData.personen.stammdaten.adresse.hausnr';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR = 'hausnr';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ =
  'gvVertragBestandPersonenData.personen.stammdaten.adresse.ikz';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ = 'ikz';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT =
  'gvVertragBestandPersonenData.personen.stammdaten.adresse.ort';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT = 'ort';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ =
  'gvVertragBestandPersonenData.personen.stammdaten.adresse.plz';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ = 'plz';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME =
  'gvVertragBestandPersonenData.personen.stammdaten.sozversanstaltName';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME = 'sozversanstaltName';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN =
  'gvVertragBestandPersonenData.personen.personRollen';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN = 'personRollen';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN =
  'gvVertragBestandPersonenData.personen.personRollen.vn';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN = 'vn';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP =
  'gvVertragBestandPersonenData.personen.personRollen.vp';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP = 'vp';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH =
  'gvVertragBestandPersonenData.personen.hauptwohnsitzOesterreich';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH = 'hauptwohnsitzOesterreich';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN =
  'gvVertragBestandPersonenData.personen.personBeziehungen';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN = 'personBeziehungen';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG =
  'gvVertragBestandPersonenData.personen.personBeziehungen.vnBeziehung';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG = 'vnBeziehung';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID =
  'gvVertragBestandPersonenData.personen.personBeziehungen.elternteilPersonId';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID =
  'elternteilPersonId';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID_2 =
  'gvVertragBestandPersonenData.personen.personBeziehungen.elternteilPersonId2';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID_2 =
  'elternteilPersonId2';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_IN_AUSBILDUNG =
  'gvVertragBestandPersonenData.personen.personBeziehungen.inAusbildung';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_IN_AUSBILDUNG = 'inAusbildung';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO =
  'gvVertragBestandPersonenData.personen.personBeziehungen.schwangerschaftsInfo';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO =
  'schwangerschaftsInfo';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_SCHWANGER =
  'gvVertragBestandPersonenData.personen.personBeziehungen.schwangerschaftsInfo.schwanger';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_SCHWANGER =
  'schwanger';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_DECKUNG =
  'gvVertragBestandPersonenData.personen.personBeziehungen.schwangerschaftsInfo.deckung';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_DECKUNG =
  'deckung';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_KINDS_VATER_PERSON_ID =
  'gvVertragBestandPersonenData.personen.personBeziehungen.schwangerschaftsInfo.kindsVaterPersonId';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_KINDS_VATER_PERSON_ID =
  'kindsVaterPersonId';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA =
  'gvVertragBestandPersonenData.personen.gvTarifData';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA = 'gvTarifData';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE = 'tarife';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_NR =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.risikoNr';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_NR = 'risikoNr';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_PRAEM_ART =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.versPraemArt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_PRAEM_ART = 'versPraemArt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZAHLWEISE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.zahlweise';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZAHLWEISE = 'zahlweise';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_HAUPTGRUPPEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.hauptgruppen';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_HAUPTGRUPPEN = 'hauptgruppen';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEWAEHLT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.ausgewaehlt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEWAEHLT = 'ausgewaehlt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_EHEPAAR_RABATT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.ehepaarRabatt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_EHEPAAR_RABATT = 'ehepaarRabatt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GK_KONTO_GVAU =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.gkKontoGvau';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GK_KONTO_GVAU = 'gkKontoGvau';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUKUENFTIGES_RISIKO =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.zukuenftigesRisiko';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUKUENFTIGES_RISIKO =
  'zukuenftigesRisiko';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERBLEIB_IN_ALTER_TARIFSERIE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.verbleibInAlterTarifserie';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERBLEIB_IN_ALTER_TARIFSERIE =
  'verbleibInAlterTarifserie';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.praemie';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE = 'praemie';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FAKTOR =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.faktor';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FAKTOR = 'faktor';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_PROZENT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.risikoProzent';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_PROZENT = 'risikoProzent';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERSICHERUNGS_BEGINN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.versicherungsBeginn';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERSICHERUNGS_BEGINN =
  'versicherungsBeginn';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ECHT_BEGINN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.echtBeginn';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ECHT_BEGINN = 'echtBeginn';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TECH_BEGINN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.techBeginn';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TECH_BEGINN = 'techBeginn';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONVERTIERUNGS_BASIS_RISIKO_NR =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.konvertierungsBasisRisikoNr';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONVERTIERUNGS_BASIS_RISIKO_NR =
  'konvertierungsBasisRisikoNr';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VB_TEXT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.vbText';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VB_TEXT = 'vbText';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_TYP =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.risikoTyp';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_TYP = 'risikoTyp';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GESCHAEFTSFALL =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.geschaeftsfall';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GESCHAEFTSFALL = 'geschaeftsfall';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIENBEFREIUNG =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.praemienbefreiung';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIENBEFREIUNG =
  'praemienbefreiung';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONV_BASIS_TARIF_SCHL =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.konvBasisTarifSchl';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONV_BASIS_TARIF_SCHL =
  'konvBasisTarifSchl';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FROM_IDD_BEDARF =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fromIddBedarf';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FROM_IDD_BEDARF = 'fromIddBedarf';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AVB_CODE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.avbCode';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AVB_CODE = 'avbCode';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE_ERWACHSEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.praemieErwachsen';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE_ERWACHSEN = 'praemieErwachsen';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ALTER_ERWACHSEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.alterErwachsen';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ALTER_ERWACHSEN = 'alterErwachsen';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GV_ALTER =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.gvAlter';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GV_ALTER = 'gvAlter';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_LEISTUNGSAUSSCHLUSS =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.leistungsausschluss';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_LEISTUNGSAUSSCHLUSS =
  'leistungsausschluss';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO = 'tarifInfo';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KBEZ =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifKbez';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KBEZ = 'tarifKbez';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SCHL =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifSchl';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SCHL = 'tarifSchl';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BEZ =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifBez';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BEZ = 'tarifBez';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_TEXT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifText';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_TEXT = 'tarifText';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_HIERARCHIE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.hierarchie';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_HIERARCHIE = 'hierarchie';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_FIRMEN_TARIF =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.firmenTarif';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_FIRMEN_TARIF =
  'firmenTarif';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_GESPERRT_AB =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.gesperrtAb';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_GESPERRT_AB = 'gesperrtAb';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KRANKEN_ANSTALTEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.krankenAnstalten';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KRANKEN_ANSTALTEN =
  'krankenAnstalten';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_BIS =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.kostenDeckungBis';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_BIS =
  'kostenDeckungBis';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_VON =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.kostenDeckungVon';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_VON =
  'kostenDeckungVon';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_GRUPPE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.konvGruppe';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_GRUPPE = 'konvGruppe';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BAUSTEIN_GRUPPE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifBausteinGruppe';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BAUSTEIN_GRUPPE =
  'tarifBausteinGruppe';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifBundeslandNichtDeckungsBundesland';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'tarifBundeslandNichtDeckungsBundesland';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_VK_GESPERRT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.vkGesperrt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_VK_GESPERRT = 'vkGesperrt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_OE_TARIF =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.oeTarif';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_OE_TARIF = 'oeTarif';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_IN_GKKTARI =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.inGkktari';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_IN_GKKTARI = 'inGkktari';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_NUR_IN_GD =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.konvNurInGD';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_NUR_IN_GD =
  'konvNurInGD';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_PK =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.pk';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_PK = 'pk';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_GRUPPE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifGruppe';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_GRUPPE =
  'tarifGruppe';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_BUNDESLAND =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.bundesland';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_BUNDESLAND = 'bundesland';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZWEIG =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifZweig';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZWEIG = 'tarifZweig';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_ANSTALTEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.sozVersAnstalten';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_ANSTALTEN =
  'sozVersAnstalten';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_TARIF_GRP =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.sozVersTarifGrp';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_TARIF_GRP =
  'sozVersTarifGrp';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SELEKTIONS_GRUPPE_1 =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifSelektionsGruppe1';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SELEKTIONS_GRUPPE_1 =
  'tarifSelektionsGruppe1';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_HAUPT_GRUPPEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifHauptGruppen';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_HAUPT_GRUPPEN =
  'tarifHauptGruppen';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KLASSE_RIKO_PR =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifKlasseRikoPr';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KLASSE_RIKO_PR =
  'tarifKlasseRikoPr';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZUSATZ_GRUPPEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifZusatzGruppen';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZUSATZ_GRUPPEN =
  'tarifZusatzGruppen';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.zusaetze';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE = 'zusaetze';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_SCHL =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.zusaetze.tarifSchl';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_SCHL = 'tarifSchl';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_KURZ_BEZEICHNUNG =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.zusaetze.kurzBezeichnung';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_KURZ_BEZEICHNUNG =
  'kurzBezeichnung';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_LANG_BEZEICHNUNG =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.zusaetze.langBezeichnung';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_LANG_BEZEICHNUNG =
  'langBezeichnung';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_ZUSATZ_PRAEMIE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.zusaetze.tarifZusatzPraemie';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_ZUSATZ_PRAEMIE =
  'tarifZusatzPraemie';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.sonderRabatte';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE = 'sonderRabatte';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_ZUSCHLAG_ART =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.sonderRabatte.zuschlagArt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_ZUSCHLAG_ART =
  'zuschlagArt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_PROZENT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.sonderRabatte.prozent';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_PROZENT = 'prozent';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.rabatte';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE = 'rabatte';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_ZUSCHLAG_ART =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.rabatte.zuschlagArt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_ZUSCHLAG_ART = 'zuschlagArt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_PROZENT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.rabatte.prozent';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_PROZENT = 'prozent';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_RABATT_ART =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.rabatte.rabattArt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_RABATT_ART = 'rabattArt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_VERRECHNUNGSKONTO =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.rabatte.verrechnungskonto';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_VERRECHNUNGSKONTO =
  'verrechnungskonto';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_CODE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.rabatte.code';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_CODE = 'code';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.klauselDetails';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS = 'klauselDetails';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_NUMMER =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.klauselDetails.klauselNummer';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_NUMMER =
  'klauselNummer';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_BIS =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.klauselDetails.klauselBis';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_BIS =
  'klauselBis';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_BED =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.versBed';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_BED = 'versBed';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO = 'fzKonto';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.konto';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO = 'konto';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO_NAME =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.kontoName';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO_NAME = 'kontoName';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_EXKLUSIV_ABBER_NR =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.exklusivAbberNr';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_EXKLUSIV_ABBER_NR =
  'exklusivAbberNr';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_VERRECHNUNGSART =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.verrechnungsart';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_VERRECHNUNGSART =
  'verrechnungsart';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_BEZEICHNUNG =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.bezeichnung';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_BEZEICHNUNG = 'bezeichnung';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_HINWEIS =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.hinweis';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_HINWEIS = 'hinweis';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_VON =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.giltVon';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_VON = 'giltVon';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_BIS =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.giltBis';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_BIS = 'giltBis';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.personalNummer';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER =
  'personalNummer';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_REGEX =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.personalNummerRegex';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_REGEX =
  'personalNummerRegex';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.personalNummerExplanation';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION =
  'personalNummerExplanation';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_DIENSTSTELLE_REQUIRED =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.dienststelleRequired';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_DIENSTSTELLE_REQUIRED =
  'dienststelleRequired';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERS_NR_ERFORDERLICH =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.persNrErforderlich';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERS_NR_ERFORDERLICH =
  'persNrErforderlich';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_RABATT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.fzKonto.rabatt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_RABATT = 'rabatt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES =
  'berechnungMessages';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE =
  'berechnungMessage';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_TXT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.txt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_TXT =
  'txt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.status';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS =
  'status';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS_DESCRIPTION =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.statusDescription';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS_DESCRIPTION =
  'statusDescription';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.field';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD =
  'field';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD_DESCRIPTION =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.fieldDescription';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD_DESCRIPTION =
  'fieldDescription';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_CODE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.code';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_CODE =
  'code';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FROM_AKTUAR_MED =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.fromAktuarMed';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FROM_AKTUAR_MED =
  'fromAktuarMed';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT =
  'tarifNichtkombinierbarMit';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KBEZ =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifKbez';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KBEZ =
  'tarifKbez';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SCHL =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifSchl';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SCHL =
  'tarifSchl';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BEZ =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifBez';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BEZ =
  'tarifBez';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_TEXT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifText';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_TEXT =
  'tarifText';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_HIERARCHIE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.hierarchie';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_HIERARCHIE =
  'hierarchie';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_FIRMEN_TARIF =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.firmenTarif';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_FIRMEN_TARIF =
  'firmenTarif';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_GESPERRT_AB =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.gesperrtAb';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_GESPERRT_AB =
  'gesperrtAb';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KRANKEN_ANSTALTEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.krankenAnstalten';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KRANKEN_ANSTALTEN =
  'krankenAnstalten';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_BIS =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.kostenDeckungBis';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_BIS =
  'kostenDeckungBis';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_VON =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.kostenDeckungVon';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_VON =
  'kostenDeckungVon';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_GRUPPE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.konvGruppe';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_GRUPPE =
  'konvGruppe';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BAUSTEIN_GRUPPE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifBausteinGruppe';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BAUSTEIN_GRUPPE =
  'tarifBausteinGruppe';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifBundeslandNichtDeckungsBundesland';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'tarifBundeslandNichtDeckungsBundesland';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_VK_GESPERRT =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.vkGesperrt';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_VK_GESPERRT =
  'vkGesperrt';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_OE_TARIF =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.oeTarif';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_OE_TARIF =
  'oeTarif';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_IN_GKKTARI =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.inGkktari';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_IN_GKKTARI =
  'inGkktari';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_NUR_IN_GD =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.konvNurInGD';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_NUR_IN_GD =
  'konvNurInGD';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_PK =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.pk';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_PK =
  'pk';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_GRUPPE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifGruppe';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_GRUPPE =
  'tarifGruppe';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_BUNDESLAND =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.bundesland';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_BUNDESLAND =
  'bundesland';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZWEIG =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifZweig';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZWEIG =
  'tarifZweig';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_ANSTALTEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.sozVersAnstalten';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_ANSTALTEN =
  'sozVersAnstalten';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_TARIF_GRP =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.sozVersTarifGrp';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_TARIF_GRP =
  'sozVersTarifGrp';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SELEKTIONS_GRUPPE_1 =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifSelektionsGruppe1';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SELEKTIONS_GRUPPE_1 =
  'tarifSelektionsGruppe1';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_HAUPT_GRUPPEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifHauptGruppen';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_HAUPT_GRUPPEN =
  'tarifHauptGruppen';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KLASSE_RIKO_PR =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifKlasseRikoPr';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KLASSE_RIKO_PR =
  'tarifKlasseRikoPr';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZUSATZ_GRUPPEN =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifZusatzGruppen';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZUSATZ_GRUPPEN =
  'tarifZusatzGruppen';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.bausteine';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE = 'bausteine';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_KBEZ =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.bausteine.kbez';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_KBEZ = 'kbez';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_DRUCK =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.bausteine.druck';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_DRUCK = 'druck';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_PRAEMIE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.bausteine.praemie';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_PRAEMIE = 'praemie';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ABLAUF =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.ablauf';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ABLAUF = 'ablauf';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_KLASSE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.tarifKlasse';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_KLASSE = 'tarifKlasse';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE =
  'erlaubteGeschaeftsfaelle';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_ID =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle.id';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_NAME =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle.name';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_NAME =
  'name';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_EBENE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle.ebene';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_EBENE =
  'ebene';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'ausgefuehrteGeschaeftsfaelle';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle.id';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID =
  'id';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle.name';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME =
  'name';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE =
  'gvVertragBestandPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle.ebene';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE =
  'ebene';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_SOZIAL_VERSICHERUNG =
  'gvVertragBestandPersonenData.personen.sozialVersicherung';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_SOZIAL_VERSICHERUNG = 'sozialVersicherung';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_NACHVERSICHERUNG_KURZPFLEGE_HAUPTFAELLIGKEIT =
  'gvVertragBestandPersonenData.personen.nachversicherungKurzpflegeHauptfaelligkeit';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_NACHVERSICHERUNG_KURZPFLEGE_HAUPTFAELLIGKEIT =
  'nachversicherungKurzpflegeHauptfaelligkeit';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE =
  'gvVertragBestandPersonenData.personen.erlaubteGeschaeftsfaelle';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE = 'erlaubteGeschaeftsfaelle';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_ID =
  'gvVertragBestandPersonenData.personen.erlaubteGeschaeftsfaelle.id';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_NAME =
  'gvVertragBestandPersonenData.personen.erlaubteGeschaeftsfaelle.name';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_EBENE =
  'gvVertragBestandPersonenData.personen.erlaubteGeschaeftsfaelle.ebene';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_EBENE = 'ebene';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'gvVertragBestandPersonenData.personen.ausgefuehrteGeschaeftsfaelle';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'ausgefuehrteGeschaeftsfaelle';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID =
  'gvVertragBestandPersonenData.personen.ausgefuehrteGeschaeftsfaelle.id';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME =
  'gvVertragBestandPersonenData.personen.ausgefuehrteGeschaeftsfaelle.name';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE =
  'gvVertragBestandPersonenData.personen.ausgefuehrteGeschaeftsfaelle.ebene';
export const ITEM_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE = 'ebene';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA = 'gvVertrag2BestandPersonenData';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA = 'gvVertrag2BestandPersonenData';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_GESAMT_PRAEMIE = 'gvVertrag2BestandPersonenData.gesamtPraemie';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_GESAMT_PRAEMIE = 'gesamtPraemie';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN = 'gvVertrag2BestandPersonenData.personen';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN = 'personen';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ID = 'gvVertrag2BestandPersonenData.personen.id';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ID = 'id';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PRAEMIE_PERSON =
  'gvVertrag2BestandPersonenData.personen.praemiePerson';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PRAEMIE_PERSON = 'praemiePerson';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN =
  'gvVertrag2BestandPersonenData.personen.stammdaten';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN = 'stammdaten';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR =
  'gvVertrag2BestandPersonenData.personen.stammdaten.partnerNr';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR = 'partnerNr';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT =
  'gvVertrag2BestandPersonenData.personen.stammdaten.geschlecht';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT = 'geschlecht';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME =
  'gvVertrag2BestandPersonenData.personen.stammdaten.vorname';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME = 'vorname';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL =
  'gvVertrag2BestandPersonenData.personen.stammdaten.titel';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL = 'titel';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT =
  'gvVertrag2BestandPersonenData.personen.stammdaten.titelNachgestellt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT = 'titelNachgestellt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL =
  'gvVertrag2BestandPersonenData.personen.stammdaten.berufstitel';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL = 'berufstitel';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP =
  'gvVertrag2BestandPersonenData.personen.stammdaten.timeStamp';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP = 'timeStamp';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME =
  'gvVertrag2BestandPersonenData.personen.stammdaten.name';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME = 'name';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM =
  'gvVertrag2BestandPersonenData.personen.stammdaten.gebdatum';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM = 'gebdatum';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND =
  'gvVertrag2BestandPersonenData.personen.stammdaten.familienstand';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND = 'familienstand';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG =
  'gvVertrag2BestandPersonenData.personen.stammdaten.berufsbezeichnung';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG = 'berufsbezeichnung';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART =
  'gvVertrag2BestandPersonenData.personen.stammdaten.beschaeftigungsart';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART = 'beschaeftigungsart';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI =
  'gvVertrag2BestandPersonenData.personen.stammdaten.beschaeftigtBei';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI = 'beschaeftigtBei';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND =
  'gvVertrag2BestandPersonenData.personen.stammdaten.geburtsland';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND = 'geburtsland';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET =
  'gvVertrag2BestandPersonenData.personen.stammdaten.nationalitaet';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET = 'nationalitaet';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON =
  'gvVertrag2BestandPersonenData.personen.stammdaten.juristischePerson';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON = 'juristischePerson';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT =
  'gvVertrag2BestandPersonenData.personen.stammdaten.sozversanstalt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT = 'sozversanstalt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE =
  'gvVertrag2BestandPersonenData.personen.stammdaten.merkurEmployee';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE = 'merkurEmployee';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER =
  'gvVertrag2BestandPersonenData.personen.stammdaten.versicherungsnummer';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER = 'versicherungsnummer';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE =
  'gvVertrag2BestandPersonenData.personen.stammdaten.adresse';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE = 'adresse';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE =
  'gvVertrag2BestandPersonenData.personen.stammdaten.adresse.strasse';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE = 'strasse';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR =
  'gvVertrag2BestandPersonenData.personen.stammdaten.adresse.hausnr';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR = 'hausnr';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ =
  'gvVertrag2BestandPersonenData.personen.stammdaten.adresse.ikz';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ = 'ikz';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT =
  'gvVertrag2BestandPersonenData.personen.stammdaten.adresse.ort';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT = 'ort';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ =
  'gvVertrag2BestandPersonenData.personen.stammdaten.adresse.plz';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ = 'plz';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME =
  'gvVertrag2BestandPersonenData.personen.stammdaten.sozversanstaltName';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME = 'sozversanstaltName';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN =
  'gvVertrag2BestandPersonenData.personen.personRollen';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN = 'personRollen';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN =
  'gvVertrag2BestandPersonenData.personen.personRollen.vn';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN = 'vn';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP =
  'gvVertrag2BestandPersonenData.personen.personRollen.vp';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP = 'vp';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH =
  'gvVertrag2BestandPersonenData.personen.hauptwohnsitzOesterreich';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH = 'hauptwohnsitzOesterreich';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN =
  'gvVertrag2BestandPersonenData.personen.personBeziehungen';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN = 'personBeziehungen';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG =
  'gvVertrag2BestandPersonenData.personen.personBeziehungen.vnBeziehung';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG = 'vnBeziehung';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID =
  'gvVertrag2BestandPersonenData.personen.personBeziehungen.elternteilPersonId';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID =
  'elternteilPersonId';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID_2 =
  'gvVertrag2BestandPersonenData.personen.personBeziehungen.elternteilPersonId2';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID_2 =
  'elternteilPersonId2';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_IN_AUSBILDUNG =
  'gvVertrag2BestandPersonenData.personen.personBeziehungen.inAusbildung';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_IN_AUSBILDUNG = 'inAusbildung';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO =
  'gvVertrag2BestandPersonenData.personen.personBeziehungen.schwangerschaftsInfo';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO =
  'schwangerschaftsInfo';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_SCHWANGER =
  'gvVertrag2BestandPersonenData.personen.personBeziehungen.schwangerschaftsInfo.schwanger';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_SCHWANGER =
  'schwanger';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_DECKUNG =
  'gvVertrag2BestandPersonenData.personen.personBeziehungen.schwangerschaftsInfo.deckung';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_DECKUNG =
  'deckung';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_KINDS_VATER_PERSON_ID =
  'gvVertrag2BestandPersonenData.personen.personBeziehungen.schwangerschaftsInfo.kindsVaterPersonId';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_KINDS_VATER_PERSON_ID =
  'kindsVaterPersonId';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA =
  'gvVertrag2BestandPersonenData.personen.gvTarifData';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA = 'gvTarifData';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE = 'tarife';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_NR =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.risikoNr';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_NR = 'risikoNr';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_PRAEM_ART =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.versPraemArt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_PRAEM_ART = 'versPraemArt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZAHLWEISE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.zahlweise';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZAHLWEISE = 'zahlweise';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_HAUPTGRUPPEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.hauptgruppen';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_HAUPTGRUPPEN = 'hauptgruppen';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEWAEHLT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.ausgewaehlt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEWAEHLT = 'ausgewaehlt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_EHEPAAR_RABATT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.ehepaarRabatt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_EHEPAAR_RABATT = 'ehepaarRabatt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GK_KONTO_GVAU =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.gkKontoGvau';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GK_KONTO_GVAU = 'gkKontoGvau';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUKUENFTIGES_RISIKO =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.zukuenftigesRisiko';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUKUENFTIGES_RISIKO =
  'zukuenftigesRisiko';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERBLEIB_IN_ALTER_TARIFSERIE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.verbleibInAlterTarifserie';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERBLEIB_IN_ALTER_TARIFSERIE =
  'verbleibInAlterTarifserie';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.praemie';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE = 'praemie';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FAKTOR =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.faktor';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FAKTOR = 'faktor';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_PROZENT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.risikoProzent';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_PROZENT = 'risikoProzent';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERSICHERUNGS_BEGINN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.versicherungsBeginn';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERSICHERUNGS_BEGINN =
  'versicherungsBeginn';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ECHT_BEGINN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.echtBeginn';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ECHT_BEGINN = 'echtBeginn';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TECH_BEGINN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.techBeginn';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TECH_BEGINN = 'techBeginn';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONVERTIERUNGS_BASIS_RISIKO_NR =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.konvertierungsBasisRisikoNr';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONVERTIERUNGS_BASIS_RISIKO_NR =
  'konvertierungsBasisRisikoNr';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VB_TEXT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.vbText';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VB_TEXT = 'vbText';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_TYP =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.risikoTyp';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_TYP = 'risikoTyp';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GESCHAEFTSFALL =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.geschaeftsfall';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GESCHAEFTSFALL = 'geschaeftsfall';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIENBEFREIUNG =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.praemienbefreiung';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIENBEFREIUNG =
  'praemienbefreiung';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONV_BASIS_TARIF_SCHL =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.konvBasisTarifSchl';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONV_BASIS_TARIF_SCHL =
  'konvBasisTarifSchl';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FROM_IDD_BEDARF =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fromIddBedarf';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FROM_IDD_BEDARF = 'fromIddBedarf';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AVB_CODE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.avbCode';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AVB_CODE = 'avbCode';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE_ERWACHSEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.praemieErwachsen';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE_ERWACHSEN =
  'praemieErwachsen';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ALTER_ERWACHSEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.alterErwachsen';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ALTER_ERWACHSEN = 'alterErwachsen';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GV_ALTER =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.gvAlter';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GV_ALTER = 'gvAlter';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_LEISTUNGSAUSSCHLUSS =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.leistungsausschluss';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_LEISTUNGSAUSSCHLUSS =
  'leistungsausschluss';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO = 'tarifInfo';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KBEZ =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifKbez';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KBEZ = 'tarifKbez';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SCHL =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifSchl';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SCHL = 'tarifSchl';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BEZ =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifBez';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BEZ = 'tarifBez';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_TEXT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifText';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_TEXT = 'tarifText';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_HIERARCHIE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.hierarchie';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_HIERARCHIE = 'hierarchie';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_FIRMEN_TARIF =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.firmenTarif';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_FIRMEN_TARIF =
  'firmenTarif';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_GESPERRT_AB =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.gesperrtAb';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_GESPERRT_AB =
  'gesperrtAb';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KRANKEN_ANSTALTEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.krankenAnstalten';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KRANKEN_ANSTALTEN =
  'krankenAnstalten';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_BIS =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.kostenDeckungBis';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_BIS =
  'kostenDeckungBis';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_VON =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.kostenDeckungVon';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_VON =
  'kostenDeckungVon';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_GRUPPE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.konvGruppe';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_GRUPPE =
  'konvGruppe';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BAUSTEIN_GRUPPE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifBausteinGruppe';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BAUSTEIN_GRUPPE =
  'tarifBausteinGruppe';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifBundeslandNichtDeckungsBundesland';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'tarifBundeslandNichtDeckungsBundesland';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_VK_GESPERRT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.vkGesperrt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_VK_GESPERRT =
  'vkGesperrt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_OE_TARIF =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.oeTarif';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_OE_TARIF = 'oeTarif';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_IN_GKKTARI =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.inGkktari';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_IN_GKKTARI = 'inGkktari';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_NUR_IN_GD =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.konvNurInGD';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_NUR_IN_GD =
  'konvNurInGD';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_PK =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.pk';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_PK = 'pk';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_GRUPPE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifGruppe';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_GRUPPE =
  'tarifGruppe';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_BUNDESLAND =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.bundesland';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_BUNDESLAND = 'bundesland';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZWEIG =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifZweig';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZWEIG =
  'tarifZweig';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_ANSTALTEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.sozVersAnstalten';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_ANSTALTEN =
  'sozVersAnstalten';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_TARIF_GRP =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.sozVersTarifGrp';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_TARIF_GRP =
  'sozVersTarifGrp';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SELEKTIONS_GRUPPE_1 =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifSelektionsGruppe1';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SELEKTIONS_GRUPPE_1 =
  'tarifSelektionsGruppe1';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_HAUPT_GRUPPEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifHauptGruppen';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_HAUPT_GRUPPEN =
  'tarifHauptGruppen';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KLASSE_RIKO_PR =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifKlasseRikoPr';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KLASSE_RIKO_PR =
  'tarifKlasseRikoPr';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZUSATZ_GRUPPEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifInfo.tarifZusatzGruppen';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZUSATZ_GRUPPEN =
  'tarifZusatzGruppen';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.zusaetze';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE = 'zusaetze';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_SCHL =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.zusaetze.tarifSchl';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_SCHL = 'tarifSchl';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_KURZ_BEZEICHNUNG =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.zusaetze.kurzBezeichnung';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_KURZ_BEZEICHNUNG =
  'kurzBezeichnung';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_LANG_BEZEICHNUNG =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.zusaetze.langBezeichnung';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_LANG_BEZEICHNUNG =
  'langBezeichnung';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_ZUSATZ_PRAEMIE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.zusaetze.tarifZusatzPraemie';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_ZUSATZ_PRAEMIE =
  'tarifZusatzPraemie';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.sonderRabatte';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE = 'sonderRabatte';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_ZUSCHLAG_ART =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.sonderRabatte.zuschlagArt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_ZUSCHLAG_ART =
  'zuschlagArt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_PROZENT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.sonderRabatte.prozent';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_PROZENT = 'prozent';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.rabatte';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE = 'rabatte';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_ZUSCHLAG_ART =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.rabatte.zuschlagArt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_ZUSCHLAG_ART = 'zuschlagArt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_PROZENT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.rabatte.prozent';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_PROZENT = 'prozent';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_RABATT_ART =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.rabatte.rabattArt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_RABATT_ART = 'rabattArt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_VERRECHNUNGSKONTO =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.rabatte.verrechnungskonto';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_VERRECHNUNGSKONTO =
  'verrechnungskonto';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_CODE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.rabatte.code';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_CODE = 'code';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.klauselDetails';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS = 'klauselDetails';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_NUMMER =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.klauselDetails.klauselNummer';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_NUMMER =
  'klauselNummer';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_BIS =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.klauselDetails.klauselBis';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_BIS =
  'klauselBis';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_BED =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.versBed';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_BED = 'versBed';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO = 'fzKonto';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.konto';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO = 'konto';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO_NAME =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.kontoName';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO_NAME = 'kontoName';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_EXKLUSIV_ABBER_NR =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.exklusivAbberNr';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_EXKLUSIV_ABBER_NR =
  'exklusivAbberNr';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_VERRECHNUNGSART =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.verrechnungsart';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_VERRECHNUNGSART =
  'verrechnungsart';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_BEZEICHNUNG =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.bezeichnung';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_BEZEICHNUNG = 'bezeichnung';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_HINWEIS =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.hinweis';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_HINWEIS = 'hinweis';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_VON =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.giltVon';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_VON = 'giltVon';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_BIS =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.giltBis';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_BIS = 'giltBis';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.personalNummer';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER =
  'personalNummer';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_REGEX =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.personalNummerRegex';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_REGEX =
  'personalNummerRegex';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.personalNummerExplanation';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION =
  'personalNummerExplanation';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_DIENSTSTELLE_REQUIRED =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.dienststelleRequired';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_DIENSTSTELLE_REQUIRED =
  'dienststelleRequired';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERS_NR_ERFORDERLICH =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.persNrErforderlich';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERS_NR_ERFORDERLICH =
  'persNrErforderlich';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_RABATT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.fzKonto.rabatt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_RABATT = 'rabatt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES =
  'berechnungMessages';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE =
  'berechnungMessage';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_TXT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.txt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_TXT =
  'txt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.status';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS =
  'status';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS_DESCRIPTION =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.statusDescription';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS_DESCRIPTION =
  'statusDescription';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.field';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD =
  'field';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD_DESCRIPTION =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.fieldDescription';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD_DESCRIPTION =
  'fieldDescription';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_CODE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.code';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_CODE =
  'code';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FROM_AKTUAR_MED =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.berechnungMessage.fromAktuarMed';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FROM_AKTUAR_MED =
  'fromAktuarMed';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT =
  'tarifNichtkombinierbarMit';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KBEZ =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifKbez';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KBEZ =
  'tarifKbez';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SCHL =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifSchl';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SCHL =
  'tarifSchl';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BEZ =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifBez';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BEZ =
  'tarifBez';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_TEXT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifText';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_TEXT =
  'tarifText';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_HIERARCHIE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.hierarchie';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_HIERARCHIE =
  'hierarchie';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_FIRMEN_TARIF =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.firmenTarif';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_FIRMEN_TARIF =
  'firmenTarif';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_GESPERRT_AB =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.gesperrtAb';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_GESPERRT_AB =
  'gesperrtAb';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KRANKEN_ANSTALTEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.krankenAnstalten';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KRANKEN_ANSTALTEN =
  'krankenAnstalten';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_BIS =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.kostenDeckungBis';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_BIS =
  'kostenDeckungBis';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_VON =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.kostenDeckungVon';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_VON =
  'kostenDeckungVon';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_GRUPPE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.konvGruppe';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_GRUPPE =
  'konvGruppe';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BAUSTEIN_GRUPPE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifBausteinGruppe';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BAUSTEIN_GRUPPE =
  'tarifBausteinGruppe';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifBundeslandNichtDeckungsBundesland';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND =
  'tarifBundeslandNichtDeckungsBundesland';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_VK_GESPERRT =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.vkGesperrt';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_VK_GESPERRT =
  'vkGesperrt';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_OE_TARIF =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.oeTarif';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_OE_TARIF =
  'oeTarif';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_IN_GKKTARI =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.inGkktari';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_IN_GKKTARI =
  'inGkktari';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_NUR_IN_GD =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.konvNurInGD';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_NUR_IN_GD =
  'konvNurInGD';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_PK =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.pk';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_PK =
  'pk';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_GRUPPE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifGruppe';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_GRUPPE =
  'tarifGruppe';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_BUNDESLAND =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.bundesland';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_BUNDESLAND =
  'bundesland';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZWEIG =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifZweig';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZWEIG =
  'tarifZweig';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_ANSTALTEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.sozVersAnstalten';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_ANSTALTEN =
  'sozVersAnstalten';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_TARIF_GRP =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.sozVersTarifGrp';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_TARIF_GRP =
  'sozVersTarifGrp';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SELEKTIONS_GRUPPE_1 =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifSelektionsGruppe1';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SELEKTIONS_GRUPPE_1 =
  'tarifSelektionsGruppe1';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_HAUPT_GRUPPEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifHauptGruppen';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_HAUPT_GRUPPEN =
  'tarifHauptGruppen';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KLASSE_RIKO_PR =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifKlasseRikoPr';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KLASSE_RIKO_PR =
  'tarifKlasseRikoPr';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZUSATZ_GRUPPEN =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.berechnungMessages.tarifNichtkombinierbarMit.tarifZusatzGruppen';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZUSATZ_GRUPPEN =
  'tarifZusatzGruppen';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.bausteine';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE = 'bausteine';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_KBEZ =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.bausteine.kbez';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_KBEZ = 'kbez';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_DRUCK =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.bausteine.druck';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_DRUCK = 'druck';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_PRAEMIE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.bausteine.praemie';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_PRAEMIE = 'praemie';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ABLAUF =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.ablauf';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ABLAUF = 'ablauf';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_KLASSE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.tarifKlasse';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_KLASSE = 'tarifKlasse';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE =
  'erlaubteGeschaeftsfaelle';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_ID =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle.id';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_NAME =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle.name';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_NAME =
  'name';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_EBENE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.erlaubteGeschaeftsfaelle.ebene';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_EBENE =
  'ebene';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'ausgefuehrteGeschaeftsfaelle';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle.id';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID =
  'id';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle.name';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME =
  'name';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE =
  'gvVertrag2BestandPersonenData.personen.gvTarifData.tarife.ausgefuehrteGeschaeftsfaelle.ebene';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE =
  'ebene';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_SOZIAL_VERSICHERUNG =
  'gvVertrag2BestandPersonenData.personen.sozialVersicherung';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_SOZIAL_VERSICHERUNG = 'sozialVersicherung';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_NACHVERSICHERUNG_KURZPFLEGE_HAUPTFAELLIGKEIT =
  'gvVertrag2BestandPersonenData.personen.nachversicherungKurzpflegeHauptfaelligkeit';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_NACHVERSICHERUNG_KURZPFLEGE_HAUPTFAELLIGKEIT =
  'nachversicherungKurzpflegeHauptfaelligkeit';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE =
  'gvVertrag2BestandPersonenData.personen.erlaubteGeschaeftsfaelle';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE = 'erlaubteGeschaeftsfaelle';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_ID =
  'gvVertrag2BestandPersonenData.personen.erlaubteGeschaeftsfaelle.id';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_NAME =
  'gvVertrag2BestandPersonenData.personen.erlaubteGeschaeftsfaelle.name';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_EBENE =
  'gvVertrag2BestandPersonenData.personen.erlaubteGeschaeftsfaelle.ebene';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_EBENE = 'ebene';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'gvVertrag2BestandPersonenData.personen.ausgefuehrteGeschaeftsfaelle';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE =
  'ausgefuehrteGeschaeftsfaelle';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID =
  'gvVertrag2BestandPersonenData.personen.ausgefuehrteGeschaeftsfaelle.id';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME =
  'gvVertrag2BestandPersonenData.personen.ausgefuehrteGeschaeftsfaelle.name';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE =
  'gvVertrag2BestandPersonenData.personen.ausgefuehrteGeschaeftsfaelle.ebene';
export const ITEM_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE = 'ebene';
export const PATH_GV_VERTRAG_INFO = 'gvVertragInfo';
export const ITEM_GV_VERTRAG_INFO = 'gvVertragInfo';
export const PATH_GV_VERTRAG_INFO_VERTRAGS_NUMMER = 'gvVertragInfo.vertragsNummer';
export const ITEM_GV_VERTRAG_INFO_VERTRAGS_NUMMER = 'vertragsNummer';
export const PATH_GV_VERTRAG_INFO_HAUPT_FAELLIGKEIT = 'gvVertragInfo.hauptFaelligkeit';
export const ITEM_GV_VERTRAG_INFO_HAUPT_FAELLIGKEIT = 'hauptFaelligkeit';
export const PATH_GV_VERTRAG_INFO_LADE_DATUM = 'gvVertragInfo.ladeDatum';
export const ITEM_GV_VERTRAG_INFO_LADE_DATUM = 'ladeDatum';
export const PATH_GV_VERTRAG_INFO_ZAHLART = 'gvVertragInfo.zahlart';
export const ITEM_GV_VERTRAG_INFO_ZAHLART = 'zahlart';
export const PATH_GV_VERTRAG_INFO_ZAHLWEISE_VERT = 'gvVertragInfo.zahlweise_vert';
export const ITEM_GV_VERTRAG_INFO_ZAHLWEISE_VERT = 'zahlweise_vert';
export const PATH_GV_VERTRAG_INFO_SCHRIFTFORM = 'gvVertragInfo.schriftform';
export const ITEM_GV_VERTRAG_INFO_SCHRIFTFORM = 'schriftform';
export const PATH_GV_VERTRAG_INFO_IBAN = 'gvVertragInfo.iban';
export const ITEM_GV_VERTRAG_INFO_IBAN = 'iban';
export const PATH_GV_VERTRAG_INFO_BIC = 'gvVertragInfo.bic';
export const ITEM_GV_VERTRAG_INFO_BIC = 'bic';
export const PATH_ERLAUBTE_GESCHAEFTSFAELLE = 'erlaubteGeschaeftsfaelle';
export const ITEM_ERLAUBTE_GESCHAEFTSFAELLE = 'erlaubteGeschaeftsfaelle';
export const PATH_ERLAUBTE_GESCHAEFTSFAELLE_ID = 'erlaubteGeschaeftsfaelle.id';
export const ITEM_ERLAUBTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_ERLAUBTE_GESCHAEFTSFAELLE_NAME = 'erlaubteGeschaeftsfaelle.name';
export const ITEM_ERLAUBTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_ERLAUBTE_GESCHAEFTSFAELLE_EBENE = 'erlaubteGeschaeftsfaelle.ebene';
export const ITEM_ERLAUBTE_GESCHAEFTSFAELLE_EBENE = 'ebene';
export const PATH_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE = 'bestandErlaubteGeschaeftsfaelle';
export const ITEM_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE = 'bestandErlaubteGeschaeftsfaelle';
export const PATH_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE_ID = 'bestandErlaubteGeschaeftsfaelle.id';
export const ITEM_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE_NAME = 'bestandErlaubteGeschaeftsfaelle.name';
export const ITEM_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE_EBENE = 'bestandErlaubteGeschaeftsfaelle.ebene';
export const ITEM_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE_EBENE = 'ebene';
export const PATH_AUSGEFUEHRTE_GESCHAEFTSFAELLE = 'ausgefuehrteGeschaeftsfaelle';
export const ITEM_AUSGEFUEHRTE_GESCHAEFTSFAELLE = 'ausgefuehrteGeschaeftsfaelle';
export const PATH_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID = 'ausgefuehrteGeschaeftsfaelle.id';
export const ITEM_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID = 'id';
export const PATH_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME = 'ausgefuehrteGeschaeftsfaelle.name';
export const ITEM_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME = 'name';
export const PATH_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE = 'ausgefuehrteGeschaeftsfaelle.ebene';
export const ITEM_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE = 'ebene';

import { ModelField, ModelGroup, ModelItemAccessor } from '@mng/model';

export class GvAngebotDataItemAccessor {
  constructor(public itemAccessor: ModelItemAccessor) {}

  getId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_ID);
  }
  getUserRights(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_USER_RIGHTS);
  }
  getModifiedDate(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_MODIFIED_DATE);
  }
  getMustRecalculate(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_MUST_RECALCULATE);
  }
  getVertragsAenderung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_AENDERUNG);
  }
  getLeistungsfall(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_LEISTUNGSFALL);
  }
  getAktenTrennung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_AKTEN_TRENNUNG);
  }
  getGlobalWarning(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GLOBAL_WARNING);
  }
  getAktenZusammenlegung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_AKTEN_ZUSAMMENLEGUNG);
  }
  getIddBeratungDurchgefuehrt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_IDD_BERATUNG_DURCHGEFUEHRT);
  }
  getVertragsAenderungInitialisiert(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_AENDERUNG_INITIALISIERT);
  }
  getVertragsAenderungsDatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_AENDERUNGS_DATUM);
  }
  getVertragszustandPerDatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGSZUSTAND_PER_DATUM);
  }
  getTodesDatumAlterVn(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_TODES_DATUM_ALTER_VN);
  }
  getTarifVersionStichtag(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_TARIF_VERSION_STICHTAG);
  }
  getVermittlerInfo(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO);
  }
  getVermittlerInfoVermittlerNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_VERMITTLER_NR);
  }
  getVermittlerInfoVermittlerName(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_VERMITTLER_NAME);
  }
  getVermittlerInfoVermittlerNameNachname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_VERMITTLER_NAME_NACHNAME);
  }
  getVermittlerInfoVermittlerNameVorname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_VERMITTLER_NAME_VORNAME);
  }
  getVermittlerInfoMakler(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_MAKLER);
  }
  getVermittlerInfoCourtage(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_COURTAGE);
  }
  getVermittlerInfoHasGv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_HAS_GV);
  }
  getVermittlerInfoHasLv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_HAS_LV);
  }
  getVermittlerInfoHasSv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_HAS_SV);
  }
  getVermittlerInfoHasUv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_HAS_UV);
  }
  getVermittlerInfoVseRequired(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_VSE_REQUIRED);
  }
  getVermittlerInfoKooperationspartner(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_KOOPERATIONSPARTNER);
  }
  getVermittlerInfoAbkommen(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_ABKOMMEN);
  }
  getVermittlerInfoAbberType(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_ABBER_TYPE);
  }
  getVermittlerInfoIsMaklerspitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_IS_MAKLERSPITZE);
  }
  getVermittlerInfoIsTeamPartnerSpitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_IS_TEAM_PARTNER_SPITZE);
  }
  getVermittlerInfoHasDisplayableSubordinates(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_HAS_DISPLAYABLE_SUBORDINATES);
  }
  getVermittlerInfoBlattAbber(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER);
  }
  getVermittlerInfoBlattAbberVermittlerNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NR);
  }
  getVermittlerInfoBlattAbberVermittlerName(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME);
  }
  getVermittlerInfoBlattAbberVermittlerNameNachname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_NACHNAME);
  }
  getVermittlerInfoBlattAbberVermittlerNameVorname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_VORNAME);
  }
  getVermittlerInfoBlattAbberMakler(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_MAKLER);
  }
  getVermittlerInfoBlattAbberCourtage(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_COURTAGE);
  }
  getVermittlerInfoBlattAbberHasGv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_HAS_GV);
  }
  getVermittlerInfoBlattAbberHasLv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_HAS_LV);
  }
  getVermittlerInfoBlattAbberHasSv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_HAS_SV);
  }
  getVermittlerInfoBlattAbberHasUv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_HAS_UV);
  }
  getVermittlerInfoBlattAbberVseRequired(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_VSE_REQUIRED);
  }
  getVermittlerInfoBlattAbberKooperationspartner(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_KOOPERATIONSPARTNER);
  }
  getVermittlerInfoBlattAbberAbkommen(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_ABKOMMEN);
  }
  getVermittlerInfoBlattAbberAbberType(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_ABBER_TYPE);
  }
  getVermittlerInfoBlattAbberIsMaklerspitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_IS_MAKLERSPITZE);
  }
  getVermittlerInfoBlattAbberIsTeamPartnerSpitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_IS_TEAM_PARTNER_SPITZE);
  }
  getVermittlerInfoBlattAbberHasDisplayableSubordinates(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERMITTLER_INFO_BLATT_ABBER_HAS_DISPLAYABLE_SUBORDINATES);
  }
  getFzKonto(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_FZ_KONTO);
  }
  getFzKontoKonto(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_KONTO);
  }
  getFzKontoKontoName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_KONTO_NAME);
  }
  getFzKontoExklusivAbberNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_EXKLUSIV_ABBER_NR);
  }
  getFzKontoVerrechnungsart(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_VERRECHNUNGSART);
  }
  getFzKontoBezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_BEZEICHNUNG);
  }
  getFzKontoHinweis(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_HINWEIS);
  }
  getFzKontoGiltVon(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_GILT_VON);
  }
  getFzKontoGiltBis(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_GILT_BIS);
  }
  getFzKontoPersonalNummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_PERSONAL_NUMMER);
  }
  getFzKontoPersonalNummerRegex(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_PERSONAL_NUMMER_REGEX);
  }
  getFzKontoPersonalNummerExplanation(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION);
  }
  getFzKontoDienststelleRequired(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_DIENSTSTELLE_REQUIRED);
  }
  getFzKontoPersNrErforderlich(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_PERS_NR_ERFORDERLICH);
  }
  getBestandFzKonto(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO);
  }
  getBestandFzKontoKonto(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_KONTO);
  }
  getBestandFzKontoKontoName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_KONTO_NAME);
  }
  getBestandFzKontoExklusivAbberNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_EXKLUSIV_ABBER_NR);
  }
  getBestandFzKontoVerrechnungsart(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_VERRECHNUNGSART);
  }
  getBestandFzKontoBezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_BEZEICHNUNG);
  }
  getBestandFzKontoHinweis(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_HINWEIS);
  }
  getBestandFzKontoGiltVon(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_GILT_VON);
  }
  getBestandFzKontoGiltBis(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_GILT_BIS);
  }
  getBestandFzKontoPersonalNummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_PERSONAL_NUMMER);
  }
  getBestandFzKontoPersonalNummerRegex(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_PERSONAL_NUMMER_REGEX);
  }
  getBestandFzKontoPersonalNummerExplanation(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION);
  }
  getBestandFzKontoDienststelleRequired(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_DIENSTSTELLE_REQUIRED);
  }
  getBestandFzKontoPersNrErforderlich(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_PERS_NR_ERFORDERLICH);
  }
  getConfig(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_CONFIG);
  }
  getConfigStichtagVersBeginn(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_CONFIG_STICHTAG_VERS_BEGINN);
  }
  getConfigStichdatumMaxOffset(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_CONFIG_STICHDATUM_MAX_OFFSET);
  }
  getConfigGvExtraWeeksFormaleAenderungImLeistungsfall(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_CONFIG_GV_EXTRA_WEEKS_FORMALE_AENDERUNG_IM_LEISTUNGSFALL);
  }
  getConfigGvValidityExceptionDates(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_CONFIG_GV_VALIDITY_EXCEPTION_DATES);
  }
  getConfigGvValidityExceptionDatesFrom(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_CONFIG_GV_VALIDITY_EXCEPTION_DATES_FROM);
  }
  getConfigGvValidityExceptionDatesTo(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_CONFIG_GV_VALIDITY_EXCEPTION_DATES_TO);
  }
  getConfigGvValidityExceptionDatesFixed(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_CONFIG_GV_VALIDITY_EXCEPTION_DATES_FIXED);
  }
  getGvPersonenData(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA);
  }
  getGvPersonenDataGesamtPraemie(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_GESAMT_PRAEMIE);
  }
  getGvPersonenDataPersonen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN);
  }
  getGvPersonenDataPersonenId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_ID);
  }
  getGvPersonenDataPersonenPraemiePerson(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PRAEMIE_PERSON);
  }
  getGvPersonenDataPersonenStammdaten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN);
  }
  getGvPersonenDataPersonenStammdatenPartnerNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR);
  }
  getGvPersonenDataPersonenStammdatenGeschlecht(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT);
  }
  getGvPersonenDataPersonenStammdatenVorname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME);
  }
  getGvPersonenDataPersonenStammdatenTitel(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL);
  }
  getGvPersonenDataPersonenStammdatenTitelNachgestellt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT);
  }
  getGvPersonenDataPersonenStammdatenBerufstitel(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL);
  }
  getGvPersonenDataPersonenStammdatenTimeStamp(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP);
  }
  getGvPersonenDataPersonenStammdatenName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME);
  }
  getGvPersonenDataPersonenStammdatenGebdatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM);
  }
  getGvPersonenDataPersonenStammdatenFamilienstand(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND);
  }
  getGvPersonenDataPersonenStammdatenBerufsbezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG);
  }
  getGvPersonenDataPersonenStammdatenBeschaeftigungsart(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART);
  }
  getGvPersonenDataPersonenStammdatenBeschaeftigtBei(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI);
  }
  getGvPersonenDataPersonenStammdatenGeburtsland(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND);
  }
  getGvPersonenDataPersonenStammdatenNationalitaet(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET);
  }
  getGvPersonenDataPersonenStammdatenJuristischePerson(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON);
  }
  getGvPersonenDataPersonenStammdatenSozversanstalt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT);
  }
  getGvPersonenDataPersonenStammdatenMerkurEmployee(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE);
  }
  getGvPersonenDataPersonenStammdatenVersicherungsnummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER);
  }
  getGvPersonenDataPersonenStammdatenAdresse(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE);
  }
  getGvPersonenDataPersonenStammdatenAdresseStrasse(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE);
  }
  getGvPersonenDataPersonenStammdatenAdresseHausnr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR);
  }
  getGvPersonenDataPersonenStammdatenAdresseIkz(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ);
  }
  getGvPersonenDataPersonenStammdatenAdresseOrt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT);
  }
  getGvPersonenDataPersonenStammdatenAdressePlz(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ);
  }
  getGvPersonenDataPersonenStammdatenSozversanstaltName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME);
  }
  getGvPersonenDataPersonenPersonRollen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN);
  }
  getGvPersonenDataPersonenPersonRollenVn(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN);
  }
  getGvPersonenDataPersonenPersonRollenVp(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP);
  }
  getGvPersonenDataPersonenHauptwohnsitzOesterreich(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH);
  }
  getGvPersonenDataPersonenPersonBeziehungen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN);
  }
  getGvPersonenDataPersonenPersonBeziehungenVnBeziehung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG);
  }
  getGvPersonenDataPersonenPersonBeziehungenElternteilPersonId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID)
    );
  }
  getGvPersonenDataPersonenPersonBeziehungenElternteilPersonId2(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID_2)
    );
  }
  getGvPersonenDataPersonenPersonBeziehungenInAusbildung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_IN_AUSBILDUNG);
  }
  getGvPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfo(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO)
    );
  }
  getGvPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfoSchwanger(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_SCHWANGER)
    );
  }
  getGvPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfoDeckung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_DECKUNG)
    );
  }
  getGvPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfoKindsVaterPersonId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_KINDS_VATER_PERSON_ID
      )
    );
  }
  getGvPersonenDataPersonenGvTarifData(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA);
  }
  getGvPersonenDataPersonenGvTarifDataTarife(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeRisikoNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_NR);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeVersPraemArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_PRAEM_ART)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeZahlweise(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZAHLWEISE);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeHauptgruppen(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_HAUPTGRUPPEN);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeAusgewaehlt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEWAEHLT);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeEhepaarRabatt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_EHEPAAR_RABATT)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeGkKontoGvau(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GK_KONTO_GVAU)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeZukuenftigesRisiko(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUKUENFTIGES_RISIKO)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeVerbleibInAlterTarifserie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERBLEIB_IN_ALTER_TARIFSERIE)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifePraemie(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFaktor(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FAKTOR);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeRisikoProzent(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_PROZENT)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeVersicherungsBeginn(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERSICHERUNGS_BEGINN)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeEchtBeginn(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ECHT_BEGINN);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTechBeginn(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TECH_BEGINN);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeKonvertierungsBasisRisikoNr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONVERTIERUNGS_BASIS_RISIKO_NR)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeVbText(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VB_TEXT);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeRisikoTyp(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_TYP);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeGeschaeftsfall(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GESCHAEFTSFALL)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifePraemienbefreiung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIENBEFREIUNG)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeKonvBasisTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONV_BASIS_TARIF_SCHL)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFromIddBedarf(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FROM_IDD_BEDARF)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeAvbCode(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AVB_CODE);
  }
  getGvPersonenDataPersonenGvTarifDataTarifePraemieErwachsen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE_ERWACHSEN)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeAlterErwachsen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ALTER_ERWACHSEN)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeGvAlter(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GV_ALTER);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeLeistungsausschluss(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_LEISTUNGSAUSSCHLUSS)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfo(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifKbez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KBEZ)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SCHL)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifBez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BEZ)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifText(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_TEXT)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoHierarchie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_HIERARCHIE)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoFirmenTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_FIRMEN_TARIF)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoGesperrtAb(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_GESPERRT_AB)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoKrankenAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KRANKEN_ANSTALTEN)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoKostenDeckungBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_BIS)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoKostenDeckungVon(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_VON)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoKonvGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_GRUPPE)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifBausteinGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BAUSTEIN_GRUPPE
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifBundeslandNichtDeckungsBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoVkGesperrt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_VK_GESPERRT)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoOeTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_OE_TARIF)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoInGkktari(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_IN_GKKTARI)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoKonvNurInGd(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_NUR_IN_GD)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoPk(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_PK)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_GRUPPE)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_BUNDESLAND)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifZweig(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZWEIG)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoSozVersAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_ANSTALTEN)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoSozVersTarifGrp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_TARIF_GRP)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifSelektionsGruppe1(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SELEKTIONS_GRUPPE_1
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifHauptGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_HAUPT_GRUPPEN)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifKlasseRikoPr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KLASSE_RIKO_PR
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifZusatzGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZUSATZ_GRUPPEN
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeZusaetze(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeZusaetzeTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_SCHL)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeZusaetzeKurzBezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_KURZ_BEZEICHNUNG)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeZusaetzeLangBezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_LANG_BEZEICHNUNG)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeZusaetzeTarifZusatzPraemie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_ZUSATZ_PRAEMIE)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeSonderRabatte(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeSonderRabatteZuschlagArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_ZUSCHLAG_ART)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeSonderRabatteProzent(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_PROZENT)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeRabatte(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeRabatteZuschlagArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_ZUSCHLAG_ART)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeRabatteProzent(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_PROZENT)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeRabatteRabattArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_RABATT_ART)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeRabatteVerrechnungskonto(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_VERRECHNUNGSKONTO)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeRabatteCode(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_CODE);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeKlauselDetails(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeKlauselDetailsKlauselNummer(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_NUMMER)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeKlauselDetailsKlauselBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_BIS)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeVersBed(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_BED);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKonto(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoKonto(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoKontoName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO_NAME)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoExklusivAbberNr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_EXKLUSIV_ABBER_NR)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoVerrechnungsart(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_VERRECHNUNGSART)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoBezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_BEZEICHNUNG)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoHinweis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_HINWEIS)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoGiltVon(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_VON)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoGiltBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_BIS)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoPersonalNummer(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoPersonalNummerRegex(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_REGEX)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoPersonalNummerExplanation(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoDienststelleRequired(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_DIENSTSTELLE_REQUIRED)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoPersNrErforderlich(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERS_NR_ERFORDERLICH)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeFzKontoRabatt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_RABATT)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessages(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessage(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageTxt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_TXT
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageStatus(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageStatusDescription(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS_DESCRIPTION
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageField(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageFieldDescription(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD_DESCRIPTION
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageCode(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_CODE
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageFromAktuarMed(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FROM_AKTUAR_MED
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMit(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifKbez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KBEZ
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SCHL
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifBez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BEZ
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifText(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_TEXT
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitHierarchie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_HIERARCHIE
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitFirmenTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_FIRMEN_TARIF
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitGesperrtAb(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_GESPERRT_AB
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKrankenAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KRANKEN_ANSTALTEN
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKostenDeckungBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_BIS
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKostenDeckungVon(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_VON
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKonvGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_GRUPPE
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifBausteinGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BAUSTEIN_GRUPPE
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifBundeslandNichtDeckungsBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitVkGesperrt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_VK_GESPERRT
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitOeTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_OE_TARIF
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitInGkktari(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_IN_GKKTARI
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKonvNurInGd(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_NUR_IN_GD
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitPk(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_PK
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_GRUPPE
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_BUNDESLAND
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifZweig(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZWEIG
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitSozVersAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_ANSTALTEN
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitSozVersTarifGrp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_TARIF_GRP
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifSelektionsGruppe1(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SELEKTIONS_GRUPPE_1
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifHauptGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_HAUPT_GRUPPEN
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifKlasseRikoPr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KLASSE_RIKO_PR
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifZusatzGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZUSATZ_GRUPPEN
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBausteine(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBausteineKbez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_KBEZ)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBausteineDruck(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_DRUCK)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeBausteinePraemie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_PRAEMIE)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeAblauf(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ABLAUF);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeTarifKlasse(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_KLASSE);
  }
  getGvPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelleId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_ID)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_NAME)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_EBENE
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE)
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelleId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME
      )
    );
  }
  getGvPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE
      )
    );
  }
  getGvPersonenDataPersonenSozialVersicherung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_SOZIAL_VERSICHERUNG);
  }
  getGvPersonenDataPersonenNachversicherungKurzpflegeHauptfaelligkeit(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_NACHVERSICHERUNG_KURZPFLEGE_HAUPTFAELLIGKEIT)
    );
  }
  getGvPersonenDataPersonenErlaubteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE);
  }
  getGvPersonenDataPersonenErlaubteGeschaeftsfaelleId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_ID);
  }
  getGvPersonenDataPersonenErlaubteGeschaeftsfaelleName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_NAME);
  }
  getGvPersonenDataPersonenErlaubteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_EBENE);
  }
  getGvPersonenDataPersonenAusgefuehrteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE);
  }
  getGvPersonenDataPersonenAusgefuehrteGeschaeftsfaelleId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID);
  }
  getGvPersonenDataPersonenAusgefuehrteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME)
    );
  }
  getGvPersonenDataPersonenAusgefuehrteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE)
    );
  }
  getGvVertragBestandPersonenData(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA);
  }
  getGvVertragBestandPersonenDataGesamtPraemie(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_GESAMT_PRAEMIE);
  }
  getGvVertragBestandPersonenDataPersonen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN);
  }
  getGvVertragBestandPersonenDataPersonenId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ID);
  }
  getGvVertragBestandPersonenDataPersonenPraemiePerson(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PRAEMIE_PERSON);
  }
  getGvVertragBestandPersonenDataPersonenStammdaten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN);
  }
  getGvVertragBestandPersonenDataPersonenStammdatenPartnerNr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenGeschlecht(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenVorname(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenTitel(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL);
  }
  getGvVertragBestandPersonenDataPersonenStammdatenTitelNachgestellt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenBerufstitel(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenTimeStamp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME);
  }
  getGvVertragBestandPersonenDataPersonenStammdatenGebdatum(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenFamilienstand(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenBerufsbezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenBeschaeftigungsart(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenBeschaeftigtBei(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenGeburtsland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenNationalitaet(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenJuristischePerson(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenSozversanstalt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenMerkurEmployee(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenVersicherungsnummer(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenAdresse(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenAdresseStrasse(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenAdresseHausnr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenAdresseIkz(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenAdresseOrt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenAdressePlz(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ)
    );
  }
  getGvVertragBestandPersonenDataPersonenStammdatenSozversanstaltName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME)
    );
  }
  getGvVertragBestandPersonenDataPersonenPersonRollen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN);
  }
  getGvVertragBestandPersonenDataPersonenPersonRollenVn(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN);
  }
  getGvVertragBestandPersonenDataPersonenPersonRollenVp(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP);
  }
  getGvVertragBestandPersonenDataPersonenHauptwohnsitzOesterreich(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH)
    );
  }
  getGvVertragBestandPersonenDataPersonenPersonBeziehungen(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN)
    );
  }
  getGvVertragBestandPersonenDataPersonenPersonBeziehungenVnBeziehung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG)
    );
  }
  getGvVertragBestandPersonenDataPersonenPersonBeziehungenElternteilPersonId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenPersonBeziehungenElternteilPersonId2(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID_2
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenPersonBeziehungenInAusbildung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_IN_AUSBILDUNG)
    );
  }
  getGvVertragBestandPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfo(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfoSchwanger(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_SCHWANGER
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfoDeckung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_DECKUNG
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfoKindsVaterPersonId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_KINDS_VATER_PERSON_ID
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifData(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA);
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarife(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeRisikoNr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_NR)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeVersPraemArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_PRAEM_ART)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeZahlweise(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZAHLWEISE)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeHauptgruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_HAUPTGRUPPEN)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeAusgewaehlt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEWAEHLT)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeEhepaarRabatt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_EHEPAAR_RABATT)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeGkKontoGvau(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GK_KONTO_GVAU)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeZukuenftigesRisiko(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUKUENFTIGES_RISIKO
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeVerbleibInAlterTarifserie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERBLEIB_IN_ALTER_TARIFSERIE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifePraemie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFaktor(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FAKTOR)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeRisikoProzent(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_PROZENT)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeVersicherungsBeginn(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERSICHERUNGS_BEGINN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeEchtBeginn(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ECHT_BEGINN)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTechBeginn(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TECH_BEGINN)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeKonvertierungsBasisRisikoNr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONVERTIERUNGS_BASIS_RISIKO_NR
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeVbText(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VB_TEXT)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeRisikoTyp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_TYP)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeGeschaeftsfall(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GESCHAEFTSFALL)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifePraemienbefreiung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIENBEFREIUNG
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeKonvBasisTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONV_BASIS_TARIF_SCHL
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFromIddBedarf(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FROM_IDD_BEDARF
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeAvbCode(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AVB_CODE)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifePraemieErwachsen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE_ERWACHSEN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeAlterErwachsen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ALTER_ERWACHSEN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeGvAlter(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GV_ALTER)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeLeistungsausschluss(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_LEISTUNGSAUSSCHLUSS
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfo(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifKbez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KBEZ
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SCHL
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifBez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BEZ
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifText(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_TEXT
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoHierarchie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_HIERARCHIE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoFirmenTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_FIRMEN_TARIF
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoGesperrtAb(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_GESPERRT_AB
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoKrankenAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KRANKEN_ANSTALTEN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoKostenDeckungBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_BIS
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoKostenDeckungVon(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_VON
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoKonvGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_GRUPPE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifBausteinGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BAUSTEIN_GRUPPE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifBundeslandNichtDeckungsBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoVkGesperrt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_VK_GESPERRT
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoOeTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_OE_TARIF
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoInGkktari(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_IN_GKKTARI
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoKonvNurInGd(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_NUR_IN_GD
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoPk(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_PK)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_GRUPPE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_BUNDESLAND
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifZweig(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZWEIG
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoSozVersAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_ANSTALTEN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoSozVersTarifGrp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_TARIF_GRP
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifSelektionsGruppe1(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SELEKTIONS_GRUPPE_1
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifHauptGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_HAUPT_GRUPPEN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifKlasseRikoPr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KLASSE_RIKO_PR
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifZusatzGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZUSATZ_GRUPPEN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeZusaetze(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeZusaetzeTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_SCHL
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeZusaetzeKurzBezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_KURZ_BEZEICHNUNG
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeZusaetzeLangBezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_LANG_BEZEICHNUNG
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeZusaetzeTarifZusatzPraemie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_ZUSATZ_PRAEMIE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeSonderRabatte(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeSonderRabatteZuschlagArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_ZUSCHLAG_ART
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeSonderRabatteProzent(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_PROZENT
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeRabatte(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeRabatteZuschlagArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_ZUSCHLAG_ART
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeRabatteProzent(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_PROZENT
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeRabatteRabattArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_RABATT_ART
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeRabatteVerrechnungskonto(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_VERRECHNUNGSKONTO
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeRabatteCode(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_CODE)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeKlauselDetails(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeKlauselDetailsKlauselNummer(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_NUMMER
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeKlauselDetailsKlauselBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_BIS
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeVersBed(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_BED)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKonto(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoKonto(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoKontoName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO_NAME
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoExklusivAbberNr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_EXKLUSIV_ABBER_NR
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoVerrechnungsart(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_VERRECHNUNGSART
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoBezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_BEZEICHNUNG
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoHinweis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_HINWEIS
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoGiltVon(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_VON
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoGiltBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_BIS
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoPersonalNummer(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoPersonalNummerRegex(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_REGEX
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoPersonalNummerExplanation(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoDienststelleRequired(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_DIENSTSTELLE_REQUIRED
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoPersNrErforderlich(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERS_NR_ERFORDERLICH
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeFzKontoRabatt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_RABATT
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessages(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessage(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageTxt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_TXT
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageStatus(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageStatusDescription(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS_DESCRIPTION
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageField(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageFieldDescription(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD_DESCRIPTION
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageCode(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_CODE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageFromAktuarMed(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FROM_AKTUAR_MED
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMit(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifKbez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KBEZ
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SCHL
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifBez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BEZ
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifText(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_TEXT
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitHierarchie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_HIERARCHIE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitFirmenTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_FIRMEN_TARIF
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitGesperrtAb(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_GESPERRT_AB
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKrankenAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KRANKEN_ANSTALTEN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKostenDeckungBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_BIS
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKostenDeckungVon(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_VON
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKonvGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_GRUPPE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifBausteinGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BAUSTEIN_GRUPPE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifBundeslandNichtDeckungsBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitVkGesperrt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_VK_GESPERRT
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitOeTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_OE_TARIF
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitInGkktari(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_IN_GKKTARI
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKonvNurInGd(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_NUR_IN_GD
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitPk(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_PK
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_GRUPPE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_BUNDESLAND
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifZweig(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZWEIG
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitSozVersAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_ANSTALTEN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitSozVersTarifGrp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_TARIF_GRP
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifSelektionsGruppe1(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SELEKTIONS_GRUPPE_1
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifHauptGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_HAUPT_GRUPPEN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifKlasseRikoPr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KLASSE_RIKO_PR
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifZusatzGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZUSATZ_GRUPPEN
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBausteine(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBausteineKbez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_KBEZ)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBausteineDruck(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_DRUCK
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeBausteinePraemie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_PRAEMIE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeAblauf(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ABLAUF)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeTarifKlasse(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_KLASSE)
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelleId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_ID
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_NAME
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_EBENE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelleId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenSozialVersicherung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_SOZIAL_VERSICHERUNG)
    );
  }
  getGvVertragBestandPersonenDataPersonenNachversicherungKurzpflegeHauptfaelligkeit(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_NACHVERSICHERUNG_KURZPFLEGE_HAUPTFAELLIGKEIT
      )
    );
  }
  getGvVertragBestandPersonenDataPersonenErlaubteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE)
    );
  }
  getGvVertragBestandPersonenDataPersonenErlaubteGeschaeftsfaelleId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_ID)
    );
  }
  getGvVertragBestandPersonenDataPersonenErlaubteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_NAME)
    );
  }
  getGvVertragBestandPersonenDataPersonenErlaubteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_EBENE)
    );
  }
  getGvVertragBestandPersonenDataPersonenAusgefuehrteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE)
    );
  }
  getGvVertragBestandPersonenDataPersonenAusgefuehrteGeschaeftsfaelleId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID)
    );
  }
  getGvVertragBestandPersonenDataPersonenAusgefuehrteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME)
    );
  }
  getGvVertragBestandPersonenDataPersonenAusgefuehrteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE)
    );
  }
  getGvVertrag2BestandPersonenData(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA);
  }
  getGvVertrag2BestandPersonenDataGesamtPraemie(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_GESAMT_PRAEMIE);
  }
  getGvVertrag2BestandPersonenDataPersonen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN);
  }
  getGvVertrag2BestandPersonenDataPersonenId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ID);
  }
  getGvVertrag2BestandPersonenDataPersonenPraemiePerson(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PRAEMIE_PERSON);
  }
  getGvVertrag2BestandPersonenDataPersonenStammdaten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN);
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenPartnerNr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenGeschlecht(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenVorname(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenTitel(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenTitelNachgestellt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenBerufstitel(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenTimeStamp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME);
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenGebdatum(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenFamilienstand(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenBerufsbezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenBeschaeftigungsart(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenBeschaeftigtBei(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenGeburtsland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenNationalitaet(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenJuristischePerson(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenSozversanstalt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenMerkurEmployee(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenVersicherungsnummer(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenAdresse(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenAdresseStrasse(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenAdresseHausnr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenAdresseIkz(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenAdresseOrt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenAdressePlz(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenStammdatenSozversanstaltName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonRollen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN);
  }
  getGvVertrag2BestandPersonenDataPersonenPersonRollenVn(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonRollenVp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenHauptwohnsitzOesterreich(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonBeziehungen(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonBeziehungenVnBeziehung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonBeziehungenElternteilPersonId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonBeziehungenElternteilPersonId2(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_ELTERNTEIL_PERSON_ID_2
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonBeziehungenInAusbildung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_IN_AUSBILDUNG)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfo(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfoSchwanger(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_SCHWANGER
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfoDeckung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_DECKUNG
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenPersonBeziehungenSchwangerschaftsInfoKindsVaterPersonId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_SCHWANGERSCHAFTS_INFO_KINDS_VATER_PERSON_ID
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifData(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA);
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarife(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeRisikoNr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_NR)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeVersPraemArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_PRAEM_ART
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeZahlweise(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZAHLWEISE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeHauptgruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_HAUPTGRUPPEN)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeAusgewaehlt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEWAEHLT)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeEhepaarRabatt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_EHEPAAR_RABATT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeGkKontoGvau(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GK_KONTO_GVAU
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeZukuenftigesRisiko(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUKUENFTIGES_RISIKO
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeVerbleibInAlterTarifserie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERBLEIB_IN_ALTER_TARIFSERIE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifePraemie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFaktor(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FAKTOR)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeRisikoProzent(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_PROZENT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeVersicherungsBeginn(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERSICHERUNGS_BEGINN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeEchtBeginn(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ECHT_BEGINN)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTechBeginn(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TECH_BEGINN)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeKonvertierungsBasisRisikoNr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONVERTIERUNGS_BASIS_RISIKO_NR
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeVbText(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VB_TEXT)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeRisikoTyp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RISIKO_TYP)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeGeschaeftsfall(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GESCHAEFTSFALL
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifePraemienbefreiung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIENBEFREIUNG
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeKonvBasisTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KONV_BASIS_TARIF_SCHL
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFromIddBedarf(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FROM_IDD_BEDARF
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeAvbCode(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AVB_CODE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifePraemieErwachsen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_PRAEMIE_ERWACHSEN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeAlterErwachsen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ALTER_ERWACHSEN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeGvAlter(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_GV_ALTER)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeLeistungsausschluss(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_LEISTUNGSAUSSCHLUSS
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfo(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifKbez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KBEZ
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SCHL
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifBez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BEZ
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifText(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_TEXT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoHierarchie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_HIERARCHIE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoFirmenTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_FIRMEN_TARIF
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoGesperrtAb(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_GESPERRT_AB
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoKrankenAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KRANKEN_ANSTALTEN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoKostenDeckungBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_BIS
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoKostenDeckungVon(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KOSTEN_DECKUNG_VON
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoKonvGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_GRUPPE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifBausteinGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BAUSTEIN_GRUPPE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifBundeslandNichtDeckungsBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoVkGesperrt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_VK_GESPERRT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoOeTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_OE_TARIF
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoInGkktari(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_IN_GKKTARI
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoKonvNurInGd(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_KONV_NUR_IN_GD
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoPk(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_PK
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_GRUPPE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_BUNDESLAND
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifZweig(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZWEIG
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoSozVersAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_ANSTALTEN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoSozVersTarifGrp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_SOZ_VERS_TARIF_GRP
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifSelektionsGruppe1(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_SELEKTIONS_GRUPPE_1
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifHauptGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_HAUPT_GRUPPEN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifKlasseRikoPr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_KLASSE_RIKO_PR
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifInfoTarifZusatzGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_INFO_TARIF_ZUSATZ_GRUPPEN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeZusaetze(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeZusaetzeTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_SCHL
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeZusaetzeKurzBezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_KURZ_BEZEICHNUNG
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeZusaetzeLangBezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_LANG_BEZEICHNUNG
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeZusaetzeTarifZusatzPraemie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ZUSAETZE_TARIF_ZUSATZ_PRAEMIE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeSonderRabatte(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeSonderRabatteZuschlagArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_ZUSCHLAG_ART
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeSonderRabatteProzent(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_SONDER_RABATTE_PROZENT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeRabatte(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeRabatteZuschlagArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_ZUSCHLAG_ART
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeRabatteProzent(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_PROZENT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeRabatteRabattArt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_RABATT_ART
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeRabatteVerrechnungskonto(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_VERRECHNUNGSKONTO
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeRabatteCode(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_RABATTE_CODE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeKlauselDetails(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeKlauselDetailsKlauselNummer(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_NUMMER
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeKlauselDetailsKlauselBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_KLAUSEL_DETAILS_KLAUSEL_BIS
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeVersBed(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_VERS_BED)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKonto(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoKonto(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoKontoName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_KONTO_NAME
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoExklusivAbberNr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_EXKLUSIV_ABBER_NR
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoVerrechnungsart(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_VERRECHNUNGSART
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoBezeichnung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_BEZEICHNUNG
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoHinweis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_HINWEIS
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoGiltVon(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_VON
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoGiltBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_GILT_BIS
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoPersonalNummer(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoPersonalNummerRegex(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_REGEX
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoPersonalNummerExplanation(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoDienststelleRequired(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_DIENSTSTELLE_REQUIRED
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoPersNrErforderlich(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_PERS_NR_ERFORDERLICH
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeFzKontoRabatt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_FZ_KONTO_RABATT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessages(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessage(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageTxt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_TXT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageStatus(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageStatusDescription(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_STATUS_DESCRIPTION
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageField(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageFieldDescription(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FIELD_DESCRIPTION
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageCode(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_CODE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesBerechnungMessageFromAktuarMed(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_BERECHNUNG_MESSAGE_FROM_AKTUAR_MED
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMit(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifKbez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KBEZ
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifSchl(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SCHL
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifBez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BEZ
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifText(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_TEXT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitHierarchie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_HIERARCHIE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitFirmenTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_FIRMEN_TARIF
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitGesperrtAb(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_GESPERRT_AB
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKrankenAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KRANKEN_ANSTALTEN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKostenDeckungBis(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_BIS
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKostenDeckungVon(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KOSTEN_DECKUNG_VON
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKonvGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_GRUPPE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifBausteinGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BAUSTEIN_GRUPPE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifBundeslandNichtDeckungsBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_BUNDESLAND_NICHT_DECKUNGS_BUNDESLAND
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitVkGesperrt(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_VK_GESPERRT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitOeTarif(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_OE_TARIF
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitInGkktari(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_IN_GKKTARI
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitKonvNurInGd(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_KONV_NUR_IN_GD
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitPk(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_PK
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifGruppe(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_GRUPPE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitBundesland(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_BUNDESLAND
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifZweig(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZWEIG
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitSozVersAnstalten(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_ANSTALTEN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitSozVersTarifGrp(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_SOZ_VERS_TARIF_GRP
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifSelektionsGruppe1(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_SELEKTIONS_GRUPPE_1
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifHauptGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_HAUPT_GRUPPEN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifKlasseRikoPr(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_KLASSE_RIKO_PR
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBerechnungMessagesTarifNichtkombinierbarMitTarifZusatzGruppen(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BERECHNUNG_MESSAGES_TARIF_NICHTKOMBINIERBAR_MIT_TARIF_ZUSATZ_GRUPPEN
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBausteine(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBausteineKbez(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_KBEZ
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBausteineDruck(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_DRUCK
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeBausteinePraemie(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_BAUSTEINE_PRAEMIE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeAblauf(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ABLAUF)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeTarifKlasse(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_TARIF_KLASSE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelleId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_ID
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_NAME
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeErlaubteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_ERLAUBTE_GESCHAEFTSFAELLE_EBENE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelleId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenGvTarifDataTarifeAusgefuehrteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_GV_TARIF_DATA_TARIFE_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenSozialVersicherung(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_SOZIAL_VERSICHERUNG)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenNachversicherungKurzpflegeHauptfaelligkeit(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_NACHVERSICHERUNG_KURZPFLEGE_HAUPTFAELLIGKEIT
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenErlaubteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenErlaubteGeschaeftsfaelleId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_ID)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenErlaubteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_NAME)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenErlaubteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_ERLAUBTE_GESCHAEFTSFAELLE_EBENE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenAusgefuehrteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenAusgefuehrteGeschaeftsfaelleId(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID)
    );
  }
  getGvVertrag2BestandPersonenDataPersonenAusgefuehrteGeschaeftsfaelleName(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME
      )
    );
  }
  getGvVertrag2BestandPersonenDataPersonenAusgefuehrteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>(
      this.itemAccessor.getModelItem(
        PATH_GV_VERTRAG_2_BESTAND_PERSONEN_DATA_PERSONEN_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE
      )
    );
  }
  getGvVertragInfo(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_INFO);
  }
  getGvVertragInfoVertragsNummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_INFO_VERTRAGS_NUMMER);
  }
  getGvVertragInfoHauptFaelligkeit(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_INFO_HAUPT_FAELLIGKEIT);
  }
  getGvVertragInfoLadeDatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_INFO_LADE_DATUM);
  }
  getGvVertragInfoZahlart(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_INFO_ZAHLART);
  }
  getGvVertragInfoZahlweiseVert(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_INFO_ZAHLWEISE_VERT);
  }
  getGvVertragInfoSchriftform(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_INFO_SCHRIFTFORM);
  }
  getGvVertragInfoIban(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_INFO_IBAN);
  }
  getGvVertragInfoBic(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_GV_VERTRAG_INFO_BIC);
  }
  getErlaubteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_ERLAUBTE_GESCHAEFTSFAELLE);
  }
  getErlaubteGeschaeftsfaelleId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_ERLAUBTE_GESCHAEFTSFAELLE_ID);
  }
  getErlaubteGeschaeftsfaelleName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_ERLAUBTE_GESCHAEFTSFAELLE_NAME);
  }
  getErlaubteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_ERLAUBTE_GESCHAEFTSFAELLE_EBENE);
  }
  getBestandErlaubteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE);
  }
  getBestandErlaubteGeschaeftsfaelleId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE_ID);
  }
  getBestandErlaubteGeschaeftsfaelleName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE_NAME);
  }
  getBestandErlaubteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_ERLAUBTE_GESCHAEFTSFAELLE_EBENE);
  }
  getAusgefuehrteGeschaeftsfaelle(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_AUSGEFUEHRTE_GESCHAEFTSFAELLE);
  }
  getAusgefuehrteGeschaeftsfaelleId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_AUSGEFUEHRTE_GESCHAEFTSFAELLE_ID);
  }
  getAusgefuehrteGeschaeftsfaelleName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_AUSGEFUEHRTE_GESCHAEFTSFAELLE_NAME);
  }
  getAusgefuehrteGeschaeftsfaelleEbene(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_AUSGEFUEHRTE_GESCHAEFTSFAELLE_EBENE);
  }
}
